/* eslint-disable no-dupe-keys */
/* eslint-disable max-len */

const es = {
  duplicate_denounce_warning: "Ya existe una denuncia activa",
  duplicate_denounce_cannot_report: "Por ahora, no puedes denunciar esta publicación.",
  no_can_report_massively_catalog_product: "No puedes denunciar masivamente productos de catálogo.",
  article_with_conflict:"Hay 2 items con este ID",
  onboarding_slide_notices: {
    step_1: {
      title: "¡Conocé las nuevas funciones!",
      description: "Ahora es más fácil traducir la sección, ver la documentación adjunta y los detalles de la publicación denunciada.",
    },
    step_2: {
      title: "Traducción al instante",
      description: "Traducí todos los contenidos de la sección en un solo clic.",
    },
    step_3: {
      title: "Documentación a la vista",
      description: "Previsualizá las imágenes que adjuntan los vendedores sin tener que descargarlas.",
    },
    step_4: {
      title: "Detalle de la publicación",
      description: "Revisá la publicación que denunciaste en el nuevo módulo al final de la sección.",
    },
    next: "Siguiente",
    ok: "Entendido",
  },
  catalogue: "catálogo",
  catalogue_id: "ID de catálogo",
  official_store: "Tienda oficial",
  international_purchase: "COMPRA INTERNACIONAL",
  article_catalogue_detail: {
    title_images: "Imágenes de catálogo",
    report_images: "Marcar imágenes como sospechosas",
    report_right: "Reportar infracción a mis derechos",
    article_denounced: "Esta publicación infrige mis derechos",
    sellers_title: "Vendedores participantes",
    sellers_subtitle: "Para marcar como sospechosa una publicación, haz clic en la tarjeta del vendedor correspondiente.",
    seller_generic_response_title: "Respuestas de este vendedor",
    seller_generic_response_subtitle: "Aquí verás las respuestas dadas por el vendedor que selecciones en la lista de participantes.",
    seller_response_title: "Respuestas de {seller_name}",
    seller_response_subtitle: "Explora las respuestas del vendedor que seleccionaste para revisar si hay otros motivos de sospecha.",
    seller_response_title_empty: "Respuestas de este vendedor",
    seller_response_subtitle_empty: "El vendedor que seleccionaste aún no ha contestado ninguna pregunta.",
    seller_history: "Ver historial del vendedor",
    seller_sales: "Ventas",
    country_search: "Comenzar la búsqueda en",
    newness_box: {
      title: "Esta es una publicación de catálogo",
      subtitle: "Se trata de una página que agrupa, bajo un único contenido, diferentes publicaciones del mismo producto ofrecidas por diferentes vendedores.",
      "item1-a": "Para denunciar las fotos de la publicación,",
      "item1-b": "selecciona la opción “Marcar imágenes como sospechosas” en la sección que muestra los detalles del producto.",
      "item2-a": "Para reportar una publicación de un vendedor específico,",
      "item2-b": "explora la columna “Vendedores participantes” y toca el botón “Marcar como sospechosa”.",
      button: "Conoce más",
      close: "Cerrar",
    },
    sort_sellers: {
      item1: "A-Z",
      item2: "Precio de menor a mayor",
      item3: "Precio de mayor a menor",
      item4: "Tiendas oficiales primero",
    },
    seller_responses_search: "Buscar en respuestas...",
  },
  multiple_denounce: {
    title: "Solicitud de denuncia",
    instruction: "Selecciona el tipo de infracción, que aplica a los productos que quieres denunciar.",
    infraction_label: "Infracción",
    infraction_placeholder: "Selecciona el tipo de infracción",
    error_loading_infractions: "Error al cargar el tipo de infracción",
    error_detail_empty: "Error al cargar el detalle de la infracción",
    detail_label: "Detalle",
    detail_placeholder: "Incluye los detalles de la infracción.",
    send_denounce: "Enviar denuncia",
    mark_as_suspicious: "Marcar como sospechosos",
    cancel: "Cancelar",
    table: {
      product: "Producto",
      country: "País",
      remove_from_selection: "Eliminar de la selección",

    },
    options: {
      no_selected: "Selecciona el tipo de infracción",
      report_code: {
        PPPI1: "Producto falsificado",
        PPPI2: "Uso indebido de marca",
        PPPI3: "Derecho de Autor -Software",
        PPPI5: "Derecho de Autor - Libros",
        PPPI6: "Derecho de Autoir - Imágenes",
        PPPI7: "Derecho de Autor - Imagen Personal",
        PPPI8: "Modelo o Diseño Industrial",
        PPPI9: "Infringe patentes, modelos de utilidad o derechos de obtentor de variedades vegetales",
        PPPI10: "Producto no destinado a la venta",
        PPPI11: "Derecho de Autor - Cursos",
        PPPI12: "Derecho de Autor - Videojuegos",
        PPPI14: "Derecho de Autor - Videos / Películas",
        PPPI15: "Derecho de Autor - Música",
        PPPI16: "Derecho de Autor - Personajes",
        PPPI17: "Derecho de Autor - Otros",
        PPPI18: "Derechos Conexos - Reproducciones Ilegales",
        PPPI19: "Derechos Conexos - Imagen Personal",
        PPPI20: "Derechos Conexos - Material Auditivo",
        PPPI21: "Derechos Conexos - Material Audiovisual",
        PPPI22: "Derechos Conexos - Transmisión Ilegal",
        PPPI23: "Derechos Conexos - Dispositivo Ilegal",
        ACUERDO: "Tengo un convenio de regulación sobre este producto.",

      },
    },
    progress: {
      processing: "Procesando denuncias...",
      processed: "Procesadas",
      remaining: "Pendientes",
      finishing: "Finalizando...",
      completed: "Proceso completado",
      summary: "Resumen",
      successful: "Exitosas",
      failed: "Fallidas",
    },
  },
  messageBox: {
    title: "¡Hola!",
    subtitle: "Queremos saber cómo ha sido tu experiencia con la herramienta de denuncias, ",
    subtitleStrong: "¿Tienes 3 minutos para contarnos?",
    button1: "Sí, claro",
    button2: "Ya lo hice",
  },
  memberJudge: {
    widget: {
      quality: "Cumplimiento de buenas prácticas:",
      excelent: "excelente",
      good: "buena",
      regular: "regular",
      critic: "crítico",
      neutral: "sin datos",
    },
    tooltip: {
      excelent: {
        title: "¡Tus denuncias son correctas!",
        subtitle: "Con tus denuncias nos ayudas a cuidar la experiencia de los compradores y a proteger tus derechos de propiedad intelectual.",
      },
      excelentWithRestriction: {
        title: "La cantidad de tus denuncias podría limitarse",
        subtitle:
          "Aunque en la mayoría de tus denuncias cumples con su proceso, algunas no se realizan adecuadamente. Evita este comportamiento para no caer en nuevas sanciones. ",
      },
      good: {
        title: "Tienes oportunidad de mejorar tus denuncias",
        subtitle:
          "La mayoría de tus denuncias se basan en infracciones de propiedad intelectual y cumples su proceso, pero detectamos algunas que no se realizan adecuadamente.",
      },
      goodWithRestriction: {
        title: "Tienes oportunidad de mejorar tus denuncias",
        subtitle: "Algunas de tus denuncias no se realizaron adecuadamente. Evita este comportamiento para no caer en nuevas sanciones. ",
      },
      regular: {
        title: "Debes mejorar tus denuncias",
        subtitle: "Asegúrate siempre de cumplir con las buenas prácticas del BPP para denunciar y seguir el proceso adecuadamente.",
      },
      regularWithRestriction: {
        title: "Debes mejorar tus denuncias",
        subtitle:
          "Asegúrate siempre de cumplir con las buenas prácticas del BPP para denunciar y seguir el proceso adecuadamente, así evitarás nuevas sanciones.",
      },
      critic: {
        title: "Estás incumpliendo las buenas prácticas del BPP",
        subtitle: "Denuncia sólo infracciones de propiedad intelectual y evita un uso incorrecto del programa.",
      },
      criticWithRestriction: {
        title: "Estás incumpliendo las buenas prácticas del BPP",
        subtitle: "Denuncia sólo infracciones de propiedad intelectual y evita un uso incorrecto del programa.",
      },

      neutral: {
        title: "Aún no has denunciado publicaciones suficientes",
        subtitle: "Cuando hagas denuncias podremos ayudarte si lo necesitaras.",
      },
      neutralWithRestriction: {
        title: "Aún no has denunciado publicaciones suficientes",
        subtitle: "Cuando hagas denuncias podremos ayudarte si lo necesitaras.",
      },
    },
    button2: "Revisar denuncias",
    alerts: {
      know_more: "Conocer más",
      new_member: {
        title: "Realiza hasta 50 denuncias por día",
        subtitle:
          "Para asegurarnos que aprendas a usar el programa correctamente, y de acuerdo a tus derechos adheridos, te permitimos realizar hasta 50 denuncias por día. ",
        subtitle2: "Cuando alcances el límite, solo podrás marcar las publicaciones como sospechosas.",
        subtitle3: "Esta medida será temporal si completas los procesos de denuncia de forma correcta.",
        subtitle3Strong_s: " Te queda {number} denuncia hoy",
        subtitle3Strong_p: " Te quedan {number} denuncias hoy",
      },
      sleepy: {
        title: "Realiza hasta 50 denuncias por día",
        subtitle:
          "Como tu cuenta no ha sido usada en un tiempo muy prolongado, queremos asegurarnos de que puedas denunciar correctamente según tus derechos adheridos, por eso te permitimos realizar hasta 50 denuncias por día. ",
        subtitleStrong: "Cuando alcances el límite, solo podrás marcar las publicaciones como sospechosas",
        subtitle2: "Esta medida será temporal si completas los procesos de denuncia de forma correcta.",
        subtitle2Strong_s: " Te queda {number} denuncia hoy",
        subtitle2Strong_p: " Te quedan {number} denuncias hoy",
      },
      restricted: {
        title: "Limitamos tu cantidad de denuncias a 50 por día",
        subtitle: "La eficiencia de tus denuncias es crítica porque no completas el proceso según los lineamientos del Brand Protection Program. ",
        subtitle2: "Cuando alcanzas tu límite de denuncias, solo puedes marcar publicaciones como sospechosas.",
        subtitle2Strong_s: " Te queda {number} denuncia hoy",
        subtitle2Strong_p: " Te quedan {number} denuncias hoy",
      },
      prevent: {
        title: "Denuncia adecuadamente y evita posibles sanciones a tu cuenta del BPP",
        subtitle: "Al revisar tus denuncias encontramos que estarías incumpliendo nuestras ",
        subtitle_link: "buenas prácticas",
        subtitle2: " Denuncia adecuadamente, de lo contrario, esto ",
        subtitle2Strong: "podría causar que te limitemos el uso de la herramienta de denuncias del BPP o te suspendamos temporalmente del programa",
        subtitle3: "Sigue nuestras recomendaciones y descubre cómo aprovechar al máximo tu cuenta.",
        checkReport: "Revisar denuncias",
      },
      restriction: {
        title: "Limitamos temporalmente tu cantidad de denuncias a {max_denounces} por día",
        subtitle: "Al denunciar publicaciones por motivos diferentes a infracciones por propiedad intelectual, estás incumpliendo nuestras ",
        subtitle_link: "buenas prácticas",
        subtitle2: "Por esto, tienes un límite de {max_denounces} ",
        subtitle2_b: "denuncias por día hasta el {date}. ",
        subtitle2Strong_s: " Te queda {number} denuncia hoy",
        subtitle2Strong_p: " Te quedan {number} denuncias hoy",
        subtitle3: "Denuncia adecuadamente y ten en cuenta que al repetir este comportamiento, ",
        subtitle3Strong: "podrías volver a causar que te limitemos el uso de la herramienta de denuncias del BPP o te suspendamos temporalmente del programa",
        subtitle4: " Si necesitas ayuda o requieres que revisemos tu caso, ",
        subtitle4_link: "contáctanos",
      },

      limitation: {
        title: "Suspendimos temporalmente tu cuenta en el BPP por {days} días",
        subtitle: "Al denunciar publicaciones reiteradamente por motivos diferentes a infracciones por propiedad intelectual, estás incumpliendo nuestras ",
        subtitle_link: "buenas prácticas",
        subtitle2: " Por esto, ",
        subtitle2Strong: "no pódras realizar nuevas denuncias hasta el {date}",
        subtitle3: "Denuncia adecuadamente y ten en cuenta que al repetir este comportamiento, ",
        subtitle3Strong: "podríamos volver a suspenderte del programa",
        subtitle4: "Si necesitas ayuda o requieres que revisemos tu caso, ",
        subtitle4_link: "contáctanos",
      },
      suspension: {
        title: "Suspendimos tu cuenta para denunciar en el BPP",
        subtitle: "Detectamos que incumpliste nuestros ",
        subtitle_link: "Términos y condiciones",
        subtitle2: " al denunciar publicaciones reiteradamente fuera del alcance del BPP. Por esto, ",
        subtitle2Strong: " tu cuenta para denunciar estará suspendida hasta que nos contactes",
        subtitle3: "Ten en cuenta que únicamente podrás: ",
        subtitle3_a: "Acceder al historial de denuncias o generar reportes. ",
        subtitle3_b: "Utilizar tu cuenta para contactarnos mediante el formulario.",
        subtitle4: "Revisa tus denuncias y si necesitas ayuda o requieres que revisemos tu caso,",
        subtitle4_link: "contáctanos",
      },
    },
  },
  efficiency: {
    title: "Eficiencia de la cuenta",
    default: "No contamos con datos suficientes para evaluar la eficiencia de tu cuenta. ",
    high: "Felicitaciones, la eficiencia de tu cuenta es muy buena. \n",
    med: "Ten cuidado, tu cuenta está en riesgo de ser restringida.  \n",
    risk: "Tu cuenta está restringida. Revisa tu eficiencia y conoce los motivos de tu restricción. ",
    subtitle: "Revisar eficiencia. ",
    subtitle2: "Conocer más. ",
  },
  blindage: {
    tooltip_title: "Ya denunciaste esta publicacion antes",
    tooltip_content:
      "Detectamos que ya habías denunciado esta publicación basándote en la misma infracción, y decidiste retirar la denuncia. Para volver a denunciarla, debes señalar si encontraste una infracción diferente. De lo contrario, podrás volver a denunciarla a partir del ",
    tooltip_link: "Quiero contactarme",
    modal_excel: {
      title: "Lista de publicaciones sospechosas enviadas",
      subtitle_errors: "Algunas publicaciones que importaste tienen errores.",
      subtitle_success: `Podrás revisar los elementos importados en la sección de "Publicaciones sospechosas".`,
      subtitle_success_mark_suspicious: "¡Listo! Marcaste como sospechosos los productos.",
      notBlindages_found: "publicaciones para denunciar",
      notBlindage_found: "publicacion para denunciar",
      blindages_found: "publicaciones que no pudieron ser procesadas",
      blindage_found: "publicación que no pudo ser procesada",
      blindages_found2: "Tus publicaciones no se pudieron procesar",
      blindage_found2: "Tu publicación no se pudo procesar",
      blindage_content: "Detectamos que ya habías denunciado estas publicaciones basándote en la misma infracción, y decidiste retirar la denuncia.",
    },
    modal_multiple: {
      title: "Publicaciones sospechosas seleccionadas",
      subtitle_success: `Podrás revisar los elementos seleccionados con éxito en la sección de "Publicaciones sospechosas".`,
      subtitle_errors: `Algunas publicaciones que seleccionaste tienen errores. Podrás revisar los elementos seleccionados con éxito en la sección de "Publicaciones sospechosas".`,
      elements: "elementos seleccionados",
      element: "elemento seleccionado",
      notBlindages_found: "publicaciones seleccionadas con éxito",
      notBlindage_found: "publicacion seleccionada con éxito",
      blindages_found: "publicaciones que no pudieron ser procesadas",
      blindage_found: "publicación que no pudo ser procesada",
    },
  },
  noData: {
    title: "Nada por aquí ...",
    subtitle: "Cuando denuncies publicaciones podrás encontrarlas aquí.",
  },
  UP: {
    offer_variants: "El vendedor ofrece ",
    variants: "{0} variantes",
    offer_variants_b: " de este producto.",
    no_forget: "No olvides revisarlas.",
    check_variants: "Revisar variantes",
    suspect_btn: "Marcar como sospechosa",
    denounced_images: "Denunciar imagenes",

    seller: "Vendedor",
    sales: "+ {sales} ventas",
    conditions: {
      title: "Condiciones de venta",
      subtitle: "Conocé las distintas condiciones que ofrece el vendedor para esta variante.",
      alert: "Ten en cuenta que si usas la selección masiva para denunciar condiciones de venta de catálogo, algunos tipos de infracción no serán aplicables. Para denunciarlas, ve a la página principal de cada una y hazlo desde allí."
    },
    table: {
      title: "Variantes",
      subtitle: "Estas son todas las variantes del producto que ofrece el vendedor.",
      selected: "seleccionada",
      selected_p: "seleccionadas",
      more_conditions: "Todas las condiciones de venta",
      check_variant: "Revisar variante",
      select_page: "Seleccionar página",
      select_all: "Seleccionar todo",
      tooltip: "Ya marcaste esta variante como sospechosa.",
    },
  },
  Kits: {
    check_kits: "Revisar productos del kits",
    check_product: "Revisar producto",
    count: "{count} productos en el kit",
    alert: {
      title: "Puede denunciar los productos que forman parte del kit",
      subtitle: "Al denunciar un producto que infrinja tus derechos de propiedad intelectual, también se afectarán los kits en los que se vende."
    },
    table: {
      title: "Productos que forman parte del kit",
      subtitle: "Estos son todos los productos que forman parte del kit."
    }
  },
  similar: "PUBLICACION AGRUPADA",
  Similar: {
    check_similar: "Revisar publicación",
    check_similars: "Revisar publicaciones similares",
    sellers_history: "Ver historial del vendedor",
    see_alls: "Ver todas las publicaciones similares",

    alert: {
      title: "Hay {0} publicaciones similares a esta",
      subtitle: "Otros vendedores ofrecen productos como este. Comprueba si sus publicaciones infringen tu propiedad intelectual."
    },
    table: {
      title: "Publicaciones similares",
      subtitle: "Estas son las publicaciones de otros vendedores.",
      publication: "Publicación",
      seller: "Vendedor",
      review: "Revisar publicación"
    },
    search: {
      title: "Publicaciones similares",
      subtitle: "Publicaciones de otros vendedores similares a "
    }
  },
  today: "hoy",
  tomorrow: "mañana",
  "see-details-denounced-onboarding": "Consulta los detalles",
  "see-details-denounced-onboarding-description": "Accede a la publicación denunciada y recuerda el motivo de cada denuncia.",
  "denounced-details-analyce-onboarding": "Analiza la respuesta",
  "denounced-details-check-onboarding": "Revisa los cambios que hizo el vendedor, sus documentos y su historial de denuncias.",
  "denounced-detail-send-answer-onboarding": "Envía tu respuesta",
  "denounced-detail-send-answer-onboarding-description": "Confirma o retracta tu denuncia una vez hayas analizado la respuesta del vendedor.",
  "redesigned-the-section": "¡Rediseñamos la sección!",
  "redesigned-the-section-description": "Ahora podrás analizar cada respuestas más fácilmente.",
  "your-denounced-ordered": "Tus denuncias, bien ordenadas",
  "your-denounced-ordered-description": "Las que vencen pronto aparecen primero, para que nada se te escape.",
  "your-answers-informed": "Analiza todos los detalles",
  "your-answers-informed-description": "Consulta en un mismo lugar los detalles de la denuncia y la respuesta del vendedor.",
  "complaint-management": "Gestión de denuncias",
  "complaint-management-answer":
    "Aquí podrás seguir el estado de tus denuncias y responder a los vendedores para decidir si quieres confirmar o retractar tu denuncia.",
  "answers-to-be-reviewed": "Respuestas por revisar",
  "answers-to-be-reviewed-answer":
    "Muestra una tabla con todas las denuncias donde has recibido respuesta del vendedor. Haz clic en el botón 'Analizar respuesta' para ver sus detalles.",
  "analyze-response": "Analizar respuesta",
  "analyze-response-answer": " Aquí verás el detalle de la denuncia que realizaste, así como los datos del vendedor que publicó el producto que denunciaste.",
  "analyze-response-answer-two": "En este apartado podrás ver los comentarios o archivos adjuntos que el vendedor te envió como respuesta.",
  "complaint-management-image-1": "pending_notices_ES.jpg",
  "complaint-management-image-2": "pending_notices_res_ES.jpg",
  "detail-answer-positive-one": "Si consideras que su respuesta es suficiente",
  "detail-answer-positive-two": "y quieres dar de baja tu denuncia, debes retractar tu denuncia.",
  "detail-answer-negative-one": "Si consideras que la respuesta del vendedor es insuficiente,",
  "detail-answer-negative-two":
    "deberás confirmar tu denuncia. En este caso, además, te pediremos que selecciones el motivo por el que rechazaste la respuesta del vendedor.",
  "closed-complaints": "Denuncias cerradas",
  "closed-complaints-answer":
    "Aquí podrás consultar el histórico de tus denuncias cerradas. Las denuncias cerradas son aquellas que finalizan porque ya le respondiste al vendedor, porque la rechazamos o porque ya dimos de baja al vendedor o la publicación.",
  "publication-detail-text": "Detalle de la publicación",
  "sold-text": "vendidos",
  "available-text:": "disponibles",
  "description-text": "Descripción",
  "attributes-text": "Características",
  "name-text": "Nombre",
  "gender-text": "Genero",
  "brand-text": "Marca",
  "article-text": "Articulo",
  "see-every-description": "Ver toda la descripción",
  "comment-pending": "Comentario",
  "optional-option": "Opcional",
  pending_textarea_placeholder: "Cuéntale al vendedor más detalles sobre tu decisión.",
  "send-answer-pending": "Envíar respuesta",
  "comment-detail-pending": "Revisa la respuesta del vendedor antes de tomar tu decisión.",
  "answer-for-seller": "Respuesta para el vendedor",
  "confirm-report": "Ratificar denuncia",
  "retract-report": "Retirar denuncia",
  "reason-for-confirmation": "Motivo de la confirmación",
  "incorrect-documentation": "La documentación no se corresponde con el producto denunciado",
  "unreadable-documentation": "La documentación es ilegible",
  "unauthorized-user-document": "No está autorizado para usar este contenido",
  "does-not-justify-stock": "No justifica el stock",
  "counterfeited-buy": "Hace una compra y es falsificado",
  "luxury-product-with-a-lot-stock": "Es un producto de lujo con demasiado stock",
  "low-average-price": "Tiene precio por debajo de la media",
  "comments-seller-null": "El vendedor no realizó comentarios",
  "list-to-back-closed-denounced": "Volver al listado de denuncias cerradas",
  "list-to-back-pending-denounced": "Volver al listado de denuncias pendientes",
  "list-to-back-noticed-denounced": "Volver al listado de historial de denuncias",
  "denounced-state": "Estado de la denuncia",
  rollbackeable: "Quiero reactivar esta publicación",
  "rollback-tooltip": "Marca esta casilla si quieres retirar esta denuncia y reactivar la publicación",
  "rollbackeable-description-title": "Motivo del retracto",
  "rollback-placeholder": "Cuéntanos tus razones para retirar la denuncia",
  "rollback-case": "Reactivar publicación",
  "rollback-success": "¡Listo! La denuncia fue retirada",
  "rollback-error": "No pudimos guardar tus cambios. Por favor, intentalo de nuevo. ",
  "retracted-reason-title": "Motivo del retracto:",
  "see-documentation": "Ver documentación",
  "attached-documentation": "Documentación adjunta",
  "see-images-updated": "Ver imágenes modificadas",
  "images-updated": "Imágenes modificadas",
  "reported-images": "Imágenes reportadas",
  "actual-images": "Imágenes actuales",
  "commets-seller": "Comentario del vendedor",
  "sellers-history": "Historial del vendedor",
  "sellers-history-modal": {
    title: "Denuncias recibidas por el vendedor",
    subtitle: "Es el historial de las denuncias más recientes recibidas por este vendedor, tanto enviadas por ti como por otros titulares de derechos.",
    receive_s: "denuncia recibida",
    receive_p: "denuncias recibidas",
    receive_n: "Sin denuncias recibidas",
    sent_s: "denuncia enviada",
    sent_p: "denuncias enviadas",
    accepted_s: "denuncia aceptada",
    accepted_p: "denuncias aceptadas",
    table: {
      th1: "Publicación",
      th2: "Fecha de denuncia",
      th3: "Motivo de denuncia",
      th4: "Respuesta del vendedor",
    },
  },
  "translate-contents": "Traducir contenidos",
  "answer-seller": "Respuesta del vendedor",
  "see-ofert-auditor": "Ver comentario del auditor",
  "see-ofert-auditor-up": "Revisar comentario del auditor",
  "auditor-comment": "Comentario del auditor",
  "auditor-said": "dijo",
  "motif-denounced": "Motivo de la denuncia",
  "see-publication": "Ver publicación denunciada",
  "download-screenshot": "Descargar captura",
  "denounced-publication": "Publicación denunciada",
  "denounced-publications": "Publicaciónes denunciadas",
  "denounced-variants": "Variantes denunciadas",
  "denounced-variants-count": "Denunciaste {count} variantes de este producto.",
  "send-answer-condition": "Si no respondes antes del vencimiento la publicacion volverá a mostrarse en Mercado Libre",
  "send-answer": "Envía tu respuesta al vendedor",
  "closed-title": "Denuncia cerrada",
  "closed-subtitle": "Puedes consultar los detalles y retirar tu denuncia, pero no comunicarte con el vendedor.",
  "rejected-title": "No pudimos procesar la denuncia",
  "rejected-subtitle": "Revisa la razón por la cual no pudimos hacerlo en el estado de la denuncia.",
  expires_text: "expira",
  "back-to-list": "Volver al listado",
  "see-report": "Ver denuncia",
  answer: "Responder",
  see: "Ver",
  "analyse-response": "Analizar respuesta",
  expires: "Vence",
  motif: "Motivo de denuncia",
  action: "Acción",
  statusMsgPaused: "Publicación pausada",
  automation: {
    newbie: {
      title: "Alcanzaste el limite de 50 denuncias diarias, no podras denunciar hasta mañana",
      text1: "Esto sucede porque tu cuenta es nueva y necesitamos evaluar que las denuncias que realizas corresponde a los derechos que adheriste",
      text2: "Por hoy, solo podras marcar las publicaciones como sospechosas",
      button: "Conocer más",
    },
    newbieInfo: {
      title: "Tienes un límite de 50 denuncias por día",
      text1: "Esto sucede porque tu cuenta es nueva y necesitamos revisar que las denuncias que realizaste corresponde a los derechos que adheriste",
      text2: "Aún puedes realizar {denounces} denuncias hoy.",
      text3: "Después de esto solo podras marcar las publicaciones como sospechosas",
      button: "Conocer más",
    },
    pending_cn: {
      title: "Tienes {30} respuestas de vendedores que vencen hoy",
      text1: "Debes revisarlas y responder para poder seguir denunciando. Si no lo haces, las publicaciones que denunciaste se reactivarán automáticamente.",
      text2: "Recuerda que, una vez recibidas, tienes 4 días para revisar la respuesta de los vendedores.",
      button: "Ir a responder",
    },
    limited_by_inefficient: {
      with_denounces_p: {
        title: "Tu cuenta ha sido restringida a {50} denuncias diarias",
        text1: "Esto sucede porque la eficiencia de tu cuenta es muy baja",
        text2: "Aún puedes realizar {number} denuncias hoy.",
        text3: "Despues de esto solo podras marcar las publicaciones como sospechosas ",
        button: "Conocer más",
      },
      with_denounces_s: {
        title: "Tu cuenta ha sido restringida a {50} denuncias diarias",
        text1: "Esto sucede porque la eficiencia de tu cuenta es muy baja",
        text2: "Aún puedes realizar {number} denuncia hoy.",
        text3: "Despues de esto solo podras marcar las publicaciones como sospechosas ",
        button: "Conocer más",
      },
      without_denounces: {
        title: "Llegaste al limite de denuncias diarias",
        text1: "Por hoy solo podras marcar las publicaciones como sospechosas",
        text2: "Te recomendamos revisar en la seccion de eficiencia los motivos por los cuales tu cuenta fue restringida.",
        button: "Conocer más",
      },
      general: {
        text3: "Revisa tu historial para conocer más.",
        button1: "Ir a Historial de denuncias",
        button2: "Conocer más",
      },
      day_limit: {
        title: "No podrás realizar más denuncias por el resto del día",
        text1: "Ya denunciaste tu máximo diario de 30.000 publicaciones.",
        text2: "Ten en cuenta que aun así podrás marcar publicaciones como sospechosas, pero no podrás enviar nuevas denuncias hasta mañana.",
      },
    },
    items_inactive: {
      case_1: "Hoy solo podrás enviar {50} denuncias.",
      case_2: {
        text1: "Ya enviaste {20} de tus {50} denuncias máximas diarias.",
        text2: "Te quedan {30}.",
      },
      case_3: {
        text1: "Ya denunciaste tu máximo diario de {50} publicaciones.",
        text2: "No podrás realizar más denuncias por el resto del día.",
      },
      tooltip: "Restringimos tus denuncias porque más del 60% fueron rechazadas en los últimos 2 meses.",
    },
    generic: {
      title: "Ya no puedes realizar denuncias",
      text: "Ten en cuenta que podrás marcar publicaciones como sospechosas, pero no podrás enviar las denuncias hasta el {date}.",
    },
    tooltip_all: {
      title: "¿Quieres enviar todas las denuncias?",
      body: "Cuando lo hagas, notificaremos al vendedor para que pueda enviarte su respuesta.",
      ok: "Enviar denuncias",
      cancel: "Cancelar",
    },
    tooltip_partial: {
      title_p: "Solo puedes enviar {10} denuncias",
      title_s: "Solo puedes enviar 1 denuncia",
      body_1: "Las publicaciones que seleccionaste superan tu límite de denuncias diarias, ",
      body_2: "pero todavía puedes enviar {10}.",
      ok_p: "Enviar {10} denuncias",
      ok_s: "Enviar 1 denuncia",
      cancel: "Cancelar",
    },
  },
  counter_notice_new_deadline_1: "Cambiamos los plazos para responder denuncias.",
  counter_notice_new_deadline_2: "Ahora tendrás 4 días para revisar la respuesta de los vendedores.",
  article_detail: {
    breadcrumb_label: "Detalle Artículo",
    description: "Descripción",
    description_up: "Descripción del Producto",
    questions: "Preguntas",
    empty_description: "El vendedor no agregó una descripción para este producto.",
    back_to_results: "Volver a resultados",
    back_to_suggested_listings: "Volver al listado de sugeridos",
    view_all_description: "Ver toda la descripción",
    last_questions: "Últimas preguntas",
    last_questions_catalogo: "Respuestas de",
    empty_questions: "Nadie hizo preguntas todavía.",
    view_more_questions: "Ver más preguntas",
    marked_as_suspicious: "Publicación marcada como sospechosa",
    motive: "Motivo",
    marked_as_trusted: "Publicación marcada como confiable",
    by: "por",
  },
  mark_as_suspicious_label: "Sospechoso",
  mark_as_trusted_label: "Confiable",
  mark_as_catalogo_label: "Ver detalles",
  original: "Orig",
  translation: "Traducción",
  translate_click_here_original: "Ver original",
  translate_click_here_translated: "Ver traducción",
  maintenance: {
    we_are_working: "¡Estamos trabajando en mejoras!",
    come_back_soon: "Regresa pronto y vuelve a iniciar sesión para conocerlas.",
    maintenance_in_progress: "Estamos realizando tareas de mantenimiento. Sepa disculpar las molestias ocasionadas.",
  },
  all_auditors: "Todos los auditores",
  there_are_not_listings_that_match: "No hay publicaciones que coincidan con tu búsqueda",
  view_more: "ver más...",
  know_more: "Conoce más",
  view_more_suggested: "Ver más sugeridos",
  view_all: "Ver todos",
  video_tutotial_link: "https://www.youtube.com/embed/s7Sa9KuAtxk?rel=0&amp;showinfo=0",
  title_snapshot_dowload: "Descarga de Snapshot",
  snapshot_dowload_error: "Hubo un error al obtener el link de descarga, intente luego.",
  snapshot_link_label: "Clic aquí para descargar el snapshot",
  new_content_available: "Nuevo contenido disponible.",
  check_report_codes_for: "Asegurate que tienes códigos de denuncias para los siguientes paises: ",
  no_report_codes_available_for: "No tienes códigos de denuncia para ",
  about_to_delete_live_search: "Deseas eliminar esta Livesearch?",
  activate_all: "Activar todos",
  countries_toggle_info: "Haz clic sobre los países que quieres excluir de tu búsqueda. Para desactivar todos, utiliza el botón de abajo.",
  authorize_btn: "Click aquí para autorizar",
  message_authorize: "Aún debes autorizar los siguientes países para realizar búsquedas y denuncias en ellos",
  activate_none: "Desactivar todos",
  expand: "Expandir",
  collapse: "Colapsar",
  activity: "Actividad",
  activity_uppercase: "ACTIVIDAD",
  apply: "Aplicar",
  apply_filters: "Aplicar cambios y actualizar artículos",
  apply_filters_error: "Lo lamentamos, pero no pudimos aplicar los filtros. Por favor, intenta nuevamente.",
  applying_filters: "Aplicando filtros",
  are_you_sure: "¿Estas seguro?",
  question_send_all_notices: "¿Enviar todas las denuncias?",
  article: "Publicación",
  disabled_article: "publicación desactivada",
  article_change_status_error: "Lo lamentamos, pero no pudimos cambiar el estado del articulo.",
  article_change_status_error_already: "Ya fue auditado dentro de tu organización.",
  articles_change_status_error: "Lo lamentamos, pero no pudimos cambiar el estado de los articulos.",
  articles_change_status_error_already: "Fueron auditados dentro de tu organización.",
  article_drop: "baja",
  article_drops: "bajas",
  article_from_white_seller: "Vendedor Objetado",
  article_ok: "Artículo Válido",
  article_invalid: "No puedes denunciar esta publicación",
  article_reference: "Id",
  article_brand_name: "Marca",
  article_part_name: "Número de pieza",
  article_type: "Tipo de Artículo",
  article_without_picture: "ARTICULO SIN FOTO",
  in_moderation_card_title: "Denuncia enviada",
  in_moderation_card_text_1: "Comprueba el estado de tus denuncias desde el ",
  in_moderation_card_text_2: "Historial de denuncias.",
  in_moderation_card_text_3: "",
  articles_to_ok_warn: "Estás a punto de cambiar el estado del artículo a OK. Esta acción no se puede deshacer.",
  articles_to_pending_warn: "El artículo volverá a estado pendiente y se perderá la información de denuncia. ¿Estás seguro?",
  mark: "Marcar",
  articles_to_report: "publicaciones como sospechosas",
  article_to_report: "publicación como sospechosa",
  articles_to_report_menu: "Publicaciones sospechosas por denunciar",
  articles_to_report_sub: "Revisa y envía tus denuncias.",
  articles_to_report_short: "Art. por denunciar",
  audited: "Auditados",
  audited_batch_title: "Auditados en modo selección multiple",
  result: "Resultado",
  results: "Resultados",
  ready_to_audit: "LISTA PARA AUDITAR",
  available_quantity: "disponibles",
  avoided_words: "Palabras a evitar",
  batch_mode: "Selección múltiple",
  batch_mode_info: "Selecciona múltiples publicaciones tocando el botón de Selección Múltiple, y haciendo clic en los pulgares arriba o abajo.",
  deselect_current_page: "Deseleccionar esta página",
  deselect_all: "Deseleccionar todas",
  select_products_to_report_same_infringement: "Selecciona productos para denunciar por el mismo tipo de infracción",
  selected_singular: "seleccionado",
  selected_plural: "seleccionados",
  brand: "Marca",
  brands: "Marcas",
  ok: "Si",
  accept: "Aceptar",
  cancel: "Cancelar",
  cancel_batch_warning: "Vas a perder todos las publicaciones seleccionadas. ¿Estás seguro?",
  category: "Categoria",
  choose_another_brand: "Seleccionar otra marca",
  choose_brand: "Seleccione una marca",
  condition_all: "Todos",
  condition_from_blacklisted_sellers: "De Vendedores Observados",
  condition_new: "Nuevo",
  condition_used: "Usado",
  condition_refurbished: "Reacondicionado",
  "official-store": "Producto de Tienda Oficial",
  "switch-translate": {
    label: "Traducir publicación",
    tooltip: {
      title: "Traduce esta publicación",
      description: "Activa nuestro traductor y analiza mejor tu denuncia.",
      button: "Entendido",
    },
    tooltip_2: {
      title: "Desactivamos esta función mientras denuncias",
      description: "Lo hicimos para que puedas analizar y marcar infracciones sobre los textos originales.",
      button: "Entendido",
    },
    snack_message: {
      title: "Esta es una traducción automática y podría contener errores",
      description:
        "Ten en cuenta que la funcionalidad es un servicio prestado por un tercero y no debe ser interpretado como una traducción oficial. Es solo una sugerencias y no es de uso obligatorio.",
    },
    error: "Tuvimos un problema y no pudimos cargar tu traducción. Inténtalo de nuevo.",
  },
  languages: {
    es: "Español",
    en: "Inglés",
    pt: "Portugués",
  },
  countries: {
    AA: "Global",
    AR: "Argentina",
    AT: "Austria",
    BE: "Belgica",
    BO: "Bolivia",
    BR: "Brasil",
    CA: "Canada",
    CH: "Suiza",
    CL: "Chile",
    CO: "Colombia",
    CR: "Costa Rica",
    DE: "Alemania",
    DO: "República Dominicana",
    RD: "República Dominicana",
    EC: "Ecuador",
    EN: "Inglaterra",
    ES: "Espana",
    FR: "Francia",
    GB: "Reino Unido",
    GT: "Guatemala",
    HN: "Honduras",
    IE: "Irlanda",
    IT: "Italia",
    MX: "Mexico",
    NI: "Nicaragua",
    NL: "Holanda",
    PA: "Panama",
    PE: "Peru",
    PR: "Puerto Rico",
    PT: "Portugal",
    PY: "Paraguay",
    SC: "Escocia",
    SV: "El Salvador",
    US: "Estados Unidos",
    UY: "Uruguay",
    VE: "Venezuela",
  },
  countries_legal: {
    AR: "Argentina",
    BO: "Bolivia",
    BR: "Brasil",
    CL: "Chile",
    CO: "Colombia",
    CR: "Costa Rica",
    DO: "Dominicana",
    EC: "Ecuador",
    GT: "Guatemala",
    HN: "Honduras",
    MX: "Mexico",
    NI: "Nicaragua",
    PA: "Panama",
    PE: "Peru",
    PY: "Paraguay",
    SV: "El Salvador",
    UY: "Uruguay",
    VE: "Venezuela",
  },
  country: "País",
  countries_select: "Países",
  country_selector_clarification: "Selecciona aquellos países en los que deseas realizar la busqueda",
  all_the_countries: "Todos los países",
  create_live_search_with_current_listings: "Crear Livesearch de los artículos actuales",
  create_report_results: "Crear reporte de Livesearch",
  create_livesearch_report_created: "Reporte creado satisfactoriamente.",
  create_livesearch_report_error: "Hubo un error al crear el reporte.",
  go_to_ls_reports: "Ir a reportes de Livesearch",
  create_search_of_black_sellers: "Crear Livesearch de todos los Vendedores Observados",
  creating: "creando",
  currency_report_results: "Seleccione moneda para reporte de resultados",
  current_listings: "Artículos Actuales",
  onboarding_slide: {
    skip: "Omitir",
    start: "Comenzar",
    slide1: {
      title: "Antes de empezar...",
      text: "Te damos algunos consejos para que puedas aprovechar al máximo nuestra herramienta.",
    },
    slide2: {
      title: "Haz búsquedas masivas",
      text: "Utiliza el campo de búsqueda para encontrar infracciones en cualquiera de los sitios de Mercado Libre.",
      image: "slide1-es.png",
    },
    slide3: {
      title: "Crea tus filtros de búsqueda",
      text: "Personaliza tus búsquedas para encontrar infractores más fácil y rápido.",
      image: "slide2-es.png",
    },
    slide4: {
      title: "Múltiples denuncias a la vez",
      text: "Reporta varias publicaciones desde una misma pantalla y en pocos clicks.",
      image: "slide3-es.png",
    },
    slide5: {
      title: "Envía todas tus denuncias",
      text: "Cuando estés listo, puedes confirmar uno a uno o todos a la vez.",
      image: "slide4-es.png",
    },
    slide6: {
      title: "¡Listo! Comienza a denunciar",
      text: "Recuerda que si tienes dudas, solo debes dirigirte a la seccion Ayuda, desde el menú.",
    },
  },
  re_branding: {
    modal_title: "Ahora somos el Brand Protection Program de Mercado Libre",
    bullet_1: {
      title: "Nuevo nombre",
      subtitle: "El Programa de Protección de Propiedad Intelectual ahora se llama Brand Protection Program.",
    },
    bullet_2: {
      title: "Nuevo sitio",
      subtitle: "Ahora con más información y las preguntas más frecuentes.",
    },
    bullet_3: {
      title: "El compromiso de siempre",
      subtitle: "Seguimos trabajando para mejorar el programa y hacer que el proceso de denuncias sea cada vez más fácil.",
    },
    check_out_what_is_new: "¡Conoce todas las novedades!",
    go_to_bpp_site: "Ir al sitio",
  },
  livesearch_onboarding: {
    title: "Simplificamos el proceso para denunciar productos",
    description: "Conoce una nueva forma más rápida con la que también podrás hacer tus denuncias.",
    start_button: "Comenzar",
  },
  livesearch_step_by_step: {
    of: "de",
    previous: "Anterior",
    next: "Siguiente",
    finish: "Entendido",
    step1: {
      title: "Selecciona los productos a denunciar",
      description: "Elige todos los que consideres que están cometiendo el mismo tipo de infracción.",
    },
    step2: {
      title: "Verifica la seleccion y solicita la denuncia",
      description: "Cuando hagas la solicitud elige el motivo, incluye detalles y enviala, o marca productos como sospechosos para denuncias después",
    },
  },
  fotoproducto_tutorial: {
    intro: {
      title: "Ahora puedes denunciar las fotografías de los productos",
      description: "Selecciona \"Fotoproducto\" si encuentras fotos con tu marca visible usada sin autorización.",
      start_button: "Comenzar",
    },
    step1: {
      title: "Selecciona \"Fotoproducto\"",
      description: "Elige esta opción para denunciar las imágenes que usen tu marca sin autorización.",
    },
    step2: {
      title: "Elige las fotos a denunciar",
      description: "Revisa la publicación y elige las fotos donde se vea tu marca usada sin permiso.",
    },
    step3: {
      title: "Completa y envía tu denuncia",
      description: "Detalla cómo usan tu marca sin permiso y elige el documento que vas a sumar como respaldo.",
    },
    of: "de",
    previous: "Anterior",
    next: "Siguiente",
    finish: "Entendido",
  },
  suggestions_slide: {
    next: "Siguiente",
    start: "Entendido",
    new_user: {
      slide1: {
        title: "Una forma más fácil de encontrar infracciones",
        text: "Analiza publicaciones que detectamos automáticamente en base a nuestros procesos y tu historial de denuncias.",
      },
      slide2: {
        title: "Cuanto más analices, mejores serán las sugerencias",
        text: "Aprendemos de tus denuncias para seguir mejorando nuestras detecciones y actualizar tus recomendados.",
      },
      slide3: {
        title: "¡Nuevo! Filtra por país y sigue tus denuncias",
        text: "Encuentra publicaciones sugeridas en los países que te interesan, y mira el progreso de tus denuncias de la última semana.",
      },
    },
    old_user: {
      tag_text: "¡Nuevo!",
      slide1: {
        title: "Filtra por país y sigue tus denuncias",
        text: "Encuentra publicaciones sugeridas en los países que te interesan, y mira el progreso de tus denuncias de la última semana.",
      },
    },
  },
  verify_profile: {
    title: "Actualiza los datos de tu cuenta",
    subtitle: "Para que podamos seguir procesando correctamente tus denuncias, necesitamos que actualices tu información.",
    expires: "Tienes tiempo hasta el",
    verify_btn: "Actualizar datos",
    remind_later: "Recuérdame más tarde",
    alert: {
      main_text: "Actualiza los datos de tu cuenta.",
      secondary_text: "Asegúrate de que tu información esté completa para que podamos seguir procesando tus denuncias.",
      review_data: "Actualizar datos",
    },
    form: {
      title: "Perfil de la cuenta",
      subtitle: "Actualiza los datos de tu cuenta. Recuerda que ",
      subtitle_b: "no podrás editarlos luego de confirmarlos.",
      confirm: "Confirmar",
      account_type: {
        verified_title: "Tipo de usuario",
        title: "¿Qué tipo de usuario quieres adherir?",
        item_titular: "Soy un titular de derechos o representante legal",
        helper_titular: "Es decir, eres el dueño de los derechos que vas a adherir o su representante legal.",
        item_apoderado: "Soy un apoderado de los derechos",
        helper_apoderado: "Es decir, eres una persona física o jurídica autorizada por el titular de los derechos para actuar en su nombre.",
      },
      attorney_accreditation: {
        title: "Acredítate como apoderado",
        name: "Nombre del apoderado:",
        name_helper: "Puede ser una persona física o una empresa.",
        subtitle: "Datos de contacto del titular",
        subtitle_helper_1: "opcional",
        subtitle_helper_2: "Puede ser el gerente de protección de marcas o IP counsel.",
        contact_name: "Nombre de contacto",
        email: "E-mail",
      },
      account_info: {
        title: "Información sobre la cuenta",
        subtitle: "El titular de derechos es:",
        natural: "Persona física",
        legal: "Persona jurídica",
        physical_fields: {
          name: "Nombre y apellido",
          country: "País",
          type: "Tipo de identificación",
          number: "Número de identificación",
        },
        legal_fields: {
          name: "Nombre o razón social",
          country: "País",
          type: "Tipo de identificación tributaria",
          number: "Número de identificación tributaria",
        },
      },
      attorney_contact: {
        title: "Contacto del representante",
        helper: "Son los datos que usaremos desde Mercado Libre para contactarnos con el representante o administrador de la cuenta.",
        name: "Nombre y apellido",
        code: "Código internacional",
        tel: "Teléfono",
        tel_helper: "Incluye el código de área.",
        email: "E-mail corporativo",
        email_ex: "Por ejemplo, juan.lopez@tuempresa.com",
        lang: "Idioma de contacto",
        lang_placeholder: "Selecciona",
      },
      public_data: {
        title: "Datos públicos",
        helper:
          "Son los datos que le enviaremos al vendedor denunciado para que se contacte contigo una vez finalizado el proceso de denuncia. Asegúrate de colocar el nombre de la marca o grupo económico para que el vendedor sepa quién lo está denunciando.",
        name: "Nombre a mostrar",
        email: "E-mail",
        email_helper: "Puede ser genérico y no debe ser un mail ya registrado en Mercado Libre.",
      },
      exit_modal: {
        title: "¿Quieres salir del formulario?",
        text: "Si abandonas la página, deberás volver a completar todos los datos.",
        back: "Volver",
        exit: "Salir",
      },
      success: {
        text: "¡Listo! Ya actualizamos tus datos.",
      },
      error_email: {
        text: "El e-mail que ingresaste ya está registrado en Mercado Libre. Ingresa otro.",
      },
    },
  },
  suggested_listings: {
    title: "Publicaciones sugeridas",
    subtitle_p: "En esta sección verás las publicaciones que encontramos en base a nuestras detecciones y tu historial de denuncias.",
    subtitle_s: "Son publicaciones que encontramos en base a nuestras detecciones y tu historial de denuncias.",
    stats: {
      box_1: {
        text1_p: "publicaciones por denunciar",
        text1_s: "publicación por denunciar",
        text2: "Denunciar",
      },
      box_2: {
        text1: "Tu progreso en los últimos 7 días",
        text2_p: "marcadas como sospechosas",
        text2_s: "marcada como sospechosa",
        text3_p: "marcadas como confiables",
        text3_s: "marcada como confiable",
        text4: "Evolución de denuncias",
        text5: "hoy",
      },
      tooltip_p: "publicaciones denunciadas",
      tooltip_s: "publicación denunciada",
    },
    item1s: "de publicaciones analizadas",
    item2s: "marcada como confiable",
    item3s1: "marcada como sospechosa",
    item3s2: "Ir a denunciar",
    item1p: "de publicaciones analizadas",
    item2p: "marcadas como confiables",
    item3p1: "marcadas como sospechosas",
    item3p2: "Ir a denunciar",
    not_results_title: "¡Ya no tienes más sugeridos!",
    not_results_link_label: "Realizar una búsqueda",
  },
  suggested_discard: {
    text_btn: "Descartar publicación",
    tooltip: {
      title: "¿No estás seguro de qué hacer?",
      description: "Ahora puedes descartar la publicación para que dejemos de mostrarla en tus resultados.",
    },
    modal: {
      title: "¿Por qué quieres descartar esta publicación?",
      subtitle: "Ten en cuenta que volveremos a mostrarla en tus resultados de búsqueda si el vendedor la modifica o recibe nuevas preguntas.",
      discard_item: {
        item1: "No estoy seguro de que contenga una infracción",
        item2: "La publicación o el producto no se corresponden con mis derechos adheridos",
        item3: "La publicación o el producto no es relevante para mi organización",
        item4: "Otro motivo",
        item1_subtext: "Es decir, no encontraste indicios precisos de que el producto es falsificado, de infracciones de propiedad intelectual, etc.",
        item2_subtext: "Es decir, los derechos que tienes no te permiten denunciar infracciones sobre esta publicación o producto.",
        item3_subtext: "Es decir, no es el foco principal de la marca o tu operación.",
        item4_subtext: "",
      },
      step_2: {
        title: "¿Puedes contarnos un poco más?",
        subtitle: "(Opcional)",
        placeholder: "Cuéntanos por qué quieres descartar la publicación.",
        btn_text: "Descartar publicación",
      },
    },
    done_article_discarded: "¡Hecho! Si la publicación recibe cambios, volveremos a mostrártela.",
  },
  file_uploader: {
    formats: "Formatos",
    maximum_size: "Peso máximo",
  },
  xlsx_import_success: {
    done: "¡Listo!",
    marked_listing: "Marcaste 1 publicación como sospechosa.",
    marked_listings: "Marcaste {0} publicaciones como sospechosas.",
    go_to_report: "Ir a denunciar",
  },
  add_suspicious_xlsx: {
    alert_easier: "Denunciar masivamente ya es más fácil.",
    alert_info: "Ahora puedes cargar una planilla con todas las publicaciones que quieras denunciar.",
    alert_btn_label: "Cargar masivamente",
    tooltip_onboarding_title: "¿Necesitas importar un listado?",
    tooltip_onboarding_text: "Ahora puedes descargar tu excel de publicaciones sospechosas desde esta sección.",
    tootip_btn_title: "Descarga aquí tu planilla",
    tootip_btn_text: "Solo podrás importar archivos que hayas descargado desde aquí.",
    modal_title: "Importar lista de publicaciones sospechosas",
    modal_subtitle_text1: "Ten en cuenta que solo podrás importar archivos que hayas descargado desde esta sección.  ",
    modal_subtitle_text2: "Descarga tu planilla de Excel",
    btn_import: "Enviar archivo",
    elements: "elementos importados",
    element: "elemento importado",
    listings_found: "publicaciones importadas con éxito",
    listing_found: "publicación importada con éxito",
    errors: "Errores",
    error: "publicacion que no pudo ser procesada",
    listings_duplicated: "publicaciones ya marcadas como sospechosas",
    listing_duplicated: "publicación ya marcada como sospechosa",
    editable_catalog_accepted: "catálogo editable aceptado",
    editable_catalogs_accepted: "catálogos editables aceptados",
    pure_catalog_rejected: "publicación de catálogo",
    pure_catalogs_rejected: "publicaciones de catálogo",
    catalog_listings: "Publicaciones de catálogo",
    download_detail: "Descarga la plantilla para revisar los errores",
    process_results_title: "Procesamos correctamente los datos subidos",
    found_count_label: "Cantidad de publicaciones que puedes agregar: ",
    not_found_count_label: "Cantidad de publicaciones que no encontramos: ",
    invalid_count_label: "Cantidad de ids inválidos: ",
    how_to_title: "Cómo armar el listado",
    how_to_bullet_1: "Incluye una publicación por fila.",
    how_to_bullet_2: "Puedes incluir tanto ID de la publicación como su URL.",
    how_to_bullet_3: "Agrega solo publicaciones del mismo país.",
    how_to_bullet_4: "Puedes importar un máximo de 1000 publicaciones a la vez.",
    how_to_bullet_5: "Asegúrate de que todas las publicaciones compartan motivo de denuncia.",
    how_to_important: "¡Importante!",
    how_to_download: "Descargar ejemplo",
    processing: "Procesando",
    empty_text: "Agregar archivo",
    empty_drag_text: "También puedes arrastrarlos",
    on_drag_text: "Suelta aquí el archivo para procesarlo",
    drag_file_too_large: "El archivo es muy pesado",
    error_reading_file: "No pudimos revisar las publicaciones. Inténtalo de nuevo más tarde.",
    only_duplicated_listings_message: "Las publicaciones ya están marcadas como sospechosas.",
    only_duplicated_listing_message: "La publicación ya está marcada como sospechosa.",
    not_enrolled_rigths_listings_message: "Las publicaciones son de un país donde no tienes derechos adheridos.",
    not_enrolled_rigths_listing_message: "La publicación es de un país donde no tienes derechos adheridos.",
    not_valid_found_message: "No se pudo cargar ninguna publicación.",
    only_one_site: "El archivo contiene publicaciones de más de un país.",
    only_one_file: "No puedes subir más de un archivo a la vez.",
    incorrect_file_format: "El archivo tiene el formato incorrecto.",
    too_many_message: "El archivo contiene más de 1000 elementos.",
    file_exceeds_maximum_size: "El archivo supera el peso máximo.",
    reason_select: "Seleccione el motivo de la denuncia",
    reason_no_selected: "El motivo no fue seleccionado",
    comment_title: "Agregar comentario",
    comment_description: "Aquí puedes agregar un comentario que acompañe a tu denuncia",
    comment_warning: " El texto debe tener al menos 5 caracteres.",
    MCU: "Cuba",
    MEC: "Ecuador",
    MPA: "Panamá",
    MBO: "Bolivia",
    MLU: "Uruguay",
    MNI: "Nicaragua",
    MPY: "Paraguay",
    MLC: "Chile",
    MLV: "Venezuela",
    MPE: "Perú",
    MPT: "Portugal",
    MSV: "El Salvador",
    MLM: "Mexico",
    MCR: "Costa Rica",
    MGT: "Guatemala",
    MHN: "Honduras",
    MLA: "Argentina",
    MLB: "Brasil",
    MRD: "Dominicana",
    MCO: "Colombia",
    valid_charters: "Solo se permiten los siguientes caracteres: A-Z a-z 0-9 . , ' & \" - _",
  },
  live_search_report_form: {
    new_report: "Nuevo reporte",
    source: "Fuente",
    option_meli_dump: "Dump",
    option_meli_api: "API",
    search_word: "Término a buscar",
    nickname_seller: "Nickname del Vendedor",
    listing_state: "Estado de publicaciones",
    all: "Todas",
    active: "Activas",
    paused: "Pausadas",
    countries: "Países",
    no_countries: "No hay países seleccionados",
    preview: "Aplicar y buscar",
    create: "Crear reporte",
    selected_country: "país seleccionado",
    selected_countries: "países seleccionados",
    clarification: "El reporte se genera utilizando datos actualizados una vez por día.",
  },
  denunciated: "denunciados",
  denunciation: "denuncia",
  download_report_results: "Descargar Reporte de Resultados",
  ebay: "eBay",
  edit: "Editar",
  email: "Email",
  enter_keyword_for_live_search: "Selecciona el criterio de búsqueda",
  start_the_search_in: "Comenzar la búsqueda en ",
  stored_searches: "Búsquedas guardadas",
  export_data: {
    reports: {
      all_sellers: "Todos los vendedores",
      audits_by: "Auditado por",
      avoid_words: "Palabras a evitar",
      blacklisted_sellers: "Vendedores observados",
      brand: "Marca",
      city: "Ciudad",
      brands: "Marcas",
      ok: "Si",
      accept: "Aceptar",
      cancel: "Cancelar",
      cancel_batch_warning: "Vas a perder todos las publicaciones seleccionadas. ¿Estás seguro?",
      category: "Categoria",
      choose_another_brand: "Seleccionar otra marca",
      choose_brand: "Seleccione una marca",
      condition_all: "Todos",
      condition_from_blacklisted_sellers: "De Vendedores Observados",
      condition_new: "Nuevo",
      condition_used: "Usado",
      condition_refurbished: "Reacondicionado",
      "official-store": "Producto de Tienda Oficial",
      languages: {
        es: "Español",
        en: "Inglés",
        pt: "Portugués",
      },
      countries: {
        AA: "Global",
        AR: "Argentina",
        AT: "Austria",
        BE: "Belgica",
        BO: "Bolivia",
        BR: "Brasil",
        CA: "Canada",
        CH: "Suiza",
        CL: "Chile",
        CO: "Colombia",
        CR: "Costa Rica",
        DE: "Alemania",
        DO: "República Dominicana",
        RD: "República Dominicana",
        EC: "Ecuador",
        EN: "Inglaterra",
        ES: "Espana",
        FR: "Francia",
        GB: "Reino Unido",
        GT: "Guatemala",
        HN: "Honduras",
        IE: "Irlanda",
        IT: "Italia",
        MX: "Mexico",
        NI: "Nicaragua",
        NL: "Holanda",
        PA: "Panama",
        PE: "Peru",
        PR: "Puerto Rico",
        PT: "Portugal",
        PY: "Paraguay",
        SC: "Escocia",
        SV: "El Salvador",
        US: "Estados Unidos",
        UY: "Uruguay",
        VE: "Venezuela",
      },
      country: "País",
      currency: "Moneda",
      date_finish: "Fecha Fin",
      date_start: "Fecha Inicio",
      generated_by: "Generado por",
      id: "Id",
      items_sold: "Artículos vendidos",
      listing_lnk: "Link artículo",
      listing_title: "Título artículo",
      listing_type: "Tipo de artículo",
      listings: "Publicaciones",
      location: "Ubicación",
      marketplace: "Marketplace",
      marketplaces: "Marketplaces",
      offered_stock: "Stock ofrecido",
      original_currency: "Moneda orig.",
      original_price: "Precio orig.",
      picture_1: "Imagen 1",
      picture_2: "Imagen 2",
      picture_3: "Imagen 3",
      picture_4: "Imagen 4",
      price: "Precio",
      price_range: "Rango de precios",
      quantity: "Cantidad",
      removed_listings: "Artículos Removidos",
      report_code: "Código reporte",
      report_currency: "Moneda Reporte",
      report_date: "Fecha reporte",
      report_description: "Descripción reporte",
      report_tags: "Tags Reporte",
      reported_listings: "Artículos Reportados",
      reports: "Reportes",
      required_words: "Palabras requeridas",
      search_by_marketplaces: "Búsqueda realizada en los siguientes Marketplaces",
      search_terms: "Términos de Búsqueda",
      seller: "Vendedor",
      seller_username: "Usuario Vendedor",
      sellers_type: "Vendedores",
      snapshot: "Snapshot",
      sold: "Vendido",
      stock: "Stock",
      tag: "Tag",
      take_down_date: "Fecha fin",
      report_status: "Estado Reporte",
      top_countries: "Top 5 Países",
      top_countries_by_publications: "Top 5 Países según número de publicaciones",
      top_reported_sellers: "Top 5 Vendedores Reportados",
      top_sellers_by_publications: "Top 5 Vendedores según número de publicaciones",
      total_value_reported_listings: "Valor Total de Artículos Reportados",
      user: "Usuario",
      value_higher_than: "Mayor a",
      value_less_than: "Menor a",
      volume_offered: "Volumen ofrecido",
      volume_reported: "Volumen reportado",
      volume_sold: "Volumen vendido",
      worksheet_executive_summary: "Resumen Ejecutivo",
      worksheet_listings: "Publicaciones",
      worksheet_marketplaces: "Marketplaces",
      worksheet_reported_listings: "Artículos Reportados",
      worksheet_sellers: "Vendedores",
      worksheet_sellers_info: "* Algunos Sitios no ofrecen datos sobre la cantidad de Valores y número de artículos vendidos.",
      worksheet_tags: "Tags",
    },
  },
  exit_create_account: "Estas seguro que deseas salir?",
  create_auditor: "Ahora puedes crear usuarios Auditores",
  auditor_user: "Usuario auditor",
  name: "Nombre",
  last_name: "Apellido",
  user_email: "E-mail",
  user: "Usuario",
  add_auditor: "Agregar auditor",
  new_password_rules: "La contraseña debe ser mayor a 8 caracteres y diferente al actual.",
  error_password_confirm: "Las contraseñas deben coincidir",
  error_password_length: "La contraseña debe contener como mínimo 8 caracteres",
  wrong_password: "Usuario o contraseña incorrecta.",
  forgot_password: "¿Olvidaste tu contraseña?",
  confirmation_code: "Código de verificación",
  enter_confirmation_code: "Ingresa el código de verificación",
  sent_to: "Te lo enviamos por e-mail a $email. Si no lo encuentras, revisa en correo no deseado.",
  did_not_receive: "No recibí el código",
  yes: "Si",
  no: "No",
  wrong_confirmation_code: "Código de verificación incorrecto",
  send_new_code: "Enviar un nuevo código?",
  set_custom_password: "Por favor setea el password personalizado",
  create_user: "Crear usuario",
  create_users: "Crear usuarios",
  continue_button: "Continuar",
  account_data: "Datos de la cuenta",
  account_data_subtitle: "Luego podrás vincular todos tus usuarios de Brand Protection Program y denunciar en varios países al mismo tiempo.",
  default_account: "Este será el usuario con el que ingresarás",
  user_already_exist: "Ya tienes una cuenta creada con este e-mail.",
  user_not_found: "El usuario no existe en el país seleccionado.",
  auditors: "Auditores",
  auditor: "Auditor",
  meli_token_authenticate_error: "Usuario incorrecto. Ingresa con tu cuenta de Brand Protection Program.",
  code_resend: "Te hemos reenviado el codigo a tu email",
  account_welcome_message: "ahora crea una cuenta para usar la nueva herramienta de denuncias",
  account_created_title: "¡Listo! Te registraste en la nueva herramienta",
  account_created_message: "Ya puedes empezar a denunciar de forma más fácil y eficiente con las nuevas herramientas de Brand Protection Program.",
  create_account_success: "Usuario creado con exito",
  main_account_info: "$account, ten en en cuenta que:",
  account_created_reminder:
    "Si normalmente denuncias en Brand Protection Program a través de proveedores que protegen tus derechos y ahora creaste un usuario para denunciar tú directamente, considera que las respuestas a tus denuncias las recibirán los proveedores y es posible que lo desconozcan.",
  account_created_recomendation: "Por eso, te recomendamos que te contactes con ellos y coordines el seguimiento.",
  look_what_you_can_do: "Mira todo lo que podrás hacer",
  begin_to_denounce: "Empezar a denunciar",
  create_account_error: "Hubo un error mientras creabamos el usuario, por favor intenta nuevamente",
  export_xls: "Exportar Plantilla",
  "main-page-welcome-msg": "Renovamos nuestro Brand Protection Program",
  "main-page-title": "Creamos nuevos procesos para identificar a vendedores infractores y sancionarlos mucho mas rapido",
  "main-page-subtitle": "Ademas, te damos las mejores herramientas:",
  "main-page-item-1": "Busca y denuncia facilmente en varios paises al mismo tiempo",
  "main-page-item-2": "Crea y guarda tus propios criterios de busqueda",
  "main-page-item-3": "Elige en que vendedores quieres enfocarte y analiza solo sus publicaciones",
  "main-page-item-4": "Accede a un reporte con todas las publicaciones denunciadas y removidas",
  "main-page-item-5": "Adhiere y renueva tus derechos mucho mas facil y rapido",
  register_as_auditor: "Registrate como auditor para empezar a denunciar y conocer todos los beneficios",
  more_about_pppi: "Mas sobre Brand Protection Program",
  help_message: "Encuentra todo lo que necesitas en la sección de %{copy_help}",
  dont_know_how_to_start: "¿No sabés cómo empezar?",
  close_help_dialog_error: "Hubo un error mientras cerrabamos el diálogo, por favor intentalo luego.",
  need_help: "¿Necesitas ayuda?",
  help: "Ayuda",
  help_href: "/noindex/pppi/support/",
  know_more_href: "https://www.mercadolibre.com.ar/noindex/pppi/landings/bpp",
  register_href: "https://www.mercadolibre.com.ar/noindex/pppi/rights/enroll/",
  contact_us: "Contactanos",
  buy_and_sell: "¡Compra y vende desde tu celular!",
  enter_your_email: "Ingresa tu email",
  old_password: "Contraseña anterior",
  new_password: "Nueva contraseña",
  new_password_confirm: "Confirmar nueva contraseña",
  password_changed_success: "Su contraseña se ha cambiado exitosamente",
  password_changed_error: "Lo sentimos, su contraseña no pudo ser cambiada, por favor intentelo luego",
  enter_your_new_password: "Ingrese su nueva contraseña",
  password_confirmation: "Confirmar contraseña",
  change_password: "Cambiar contraseña",
  changing_password: "Cambiando contraseña",
  send_email: "enviar",
  sending_email: "enviando email",
  sendind_email: "enviando",
  failed_articles_message: "Esta Livesearch no pudo ser completada exitosamente, hubo %{count} artículos que no han sido cargados",
  filter_profile: {
    attributes: "Atributos",
    brand: "Marca",
    allBrands: "Todas las marcas",
    model: "Modelo",
    allModels: "Todos los modelos",
    noOption: "Sin opciones",
    seller_blacklisted: "Vendedores observados",
    "clarification-p1": "Al hacer click en ",
    "clarification-p2": "Aplicar y buscar, ",
    "clarification-p3": "tus preferencias se guardarán automáticamente.",
    all: "Todos",
    apply_filters: "Aplicar y buscar",
    article_condition: "Condición",
    categories: "Categorías",
    none_category: "Ninguna",
    no_subcategories_for: "No hay subcategorías para",
    no_category_selected: "No has seleccionado ninguna categoría",
    info_categories_language: "Mostraremos las categorías en el idioma del sitio donde estás buscando.",
    change: "Modificar",
    article_new: "Nuevos",
    article_used: "Usados",
    available_quantity: "Stock ofrecido",
    banned_keywords: "Términos a evitar",
    copy_of: "Copia de %{name}",
    "country.name": "País",
    "prices.USD": "Precio",
    date_range: "Rango de fechas",
    default: "Predeterminada",
    extended_data_warning: "Esto traerá artículos solamente de sitios que provean este tipo de información.",
    extended_data_sites_list: "Sitios disponibles: %{sites}.",
    fromDate: "Fecha Desde",
    fromPrice: "Mínimo",
    greater_than: "Mayor que",
    no_name: "Sin nombre",
    portal: "Portal",
    price_range: "Precio",
    required_keywords: "Términos requeridos",
    seller: "Vendedores",
    seller_blafilter_profileklisted: "Vendedores observados",
    no_seller_selected: "No has seleccionado ningún vendedor",
    none_seller: "Ninguno",
    sold_quantity: "Stock vendido",
    sort_by: "Ordenar por",
    select_sort_by: "Seleccione",
    title: "Perfiles de filtros para esta Livesearch",
    toPrice: "Máximo",
    toDate: "Fecha Hasta",
    select_one_site: "Selecciona al menos un país",
    indexed_at: "indexado",
    clean_filter: 'Limpiar Filtros'
  },
  filter: "Editar filtros",
  clean_filter: "Quitar filtros",
  filtered: "Filtrados",
  filtered_results: "Resultados filtrados",
  filters_title: "FILTROS DE BUSQUEDA - Refinar resultados",
  forgot_your_password: "¿Olvidaste tu contraseña?",
  generating_report_results: "Generando Reporte de Resultados",
  greater_than: "mayor que",
  home_title: "Brand Monitoring",
  in_progress: "En proceso",
  processing: "Procesando",
  language: "Idioma",
  live_search: "Livesearch",
  live_search_all_loaded: "Todos los resultados han sido mostrados",
  live_search_fetch_error: "Lo lamentamos, pero hubo un error cuando buscábamos la Livesearch. Por favor, intenta nuevamente.",
  live_search_create_error: "Lo lamentamos, pero hubo un error cuando creabamos la Livesearch. Por favor, intenta nuevamente.",
  live_search_refresh_error: "Lo lamentamos, pero hubo un error cuando atualizabamos la Livesearch. Por favor. intenta nuevamente.",
  live_search_delete_error: "Lo lamentamos, pero hubo un error cuando eliminabamos la Livesearch. Por favor, intenta nuevamente.",
  live_search_filters: "Filtros de búsqueda",
  live_search_loading_results: "Cargando mas resultados",
  live_search_queue_header: "COLA DE TRABAJO - Búsquedas realizadas y en proceso",
  live_search_recent: "RECIENTE",
  live_search_refinements_error: "Lo lamentamos, pero hubo un error cuando aplicabamos los filtros. Por favor, intenta nuevamente.",
  live_search_reloading: "Volviendo a ejecutar",
  live_search_results: "Resultados filtrados de búsqueda",
  live_search_empty: "Aún no se han cargado articulos",
  show_hidden_publications: "Ver publicaciones ocultas",
  hidden_tooltip_text: "Hemos ocultado las publicaciones que marcaste como no infractoras, que ya denunciaste o que pertenecen a vendedores confiables.",
  in_moderation: "Reportadas",
  validated: "No infractoras",
  denounced: "Reportadas",
  multiple_selector: {
    advice: "Ten en cuenta que no puedes utilizar selección múltiple para denunciar por derechos de autor de imágenes.",
    trusted: "Confiables",
    suspicious: "Sospechosas",
    tooltip_text: "No puedes utilizar esta función para denunciar usos no autorizados de imágenes.",
    select_all_page: "Seleccionar toda la página",
    max_selection_reached: "Máximo 50 elementos seleccionados",
    selection_limit_reached: "Llegaste al límite de productos seleccionados.",
    selection_limit_tooltip: "Alcanzaste el límite de productos que puedes seleccionar por día.",
    selection_limit_info_tooltip: "En esta página solo puedes solicitar la denuncia de un número limitado de productos, pero en general puedes elegir hasta 50 productos por día.",
    max: "máx.",
  },
  quick_search: "Búsqueda rápida",
  quick_search_placeholder: "Busca por palabra clave, código EAN o número de pieza",
  publication_id: "ID de la publicación",
  publication_id_placeholder: "MLB-745531777 o MLB745531777",
  publication_id_helper: "Encuentra el ID completo en la URL de la publicación. Puedes ingresarlo sin guion medio.",
  seller_nickname: "Nombre del vendedor",
  search_label_seller: "Términos a buscar (opcional)",
  search_label_publication: "Búsqueda rápida",
  url: "URL",
  no_matches: "No hay publicaciones que coincidan con tu búsqueda",
  no_matches_advice1: "Revisa la ortografía o utiliza palabras más genéricas.",
  no_matches_advice2: "Prueba eliminando algunos de los términos.",
  no_matches_advice3: "Asegúrate de que el vendedor siga activo en el sitio.",
  no_matches_advice4: "Editar filtros",
  nothing_here: "Nada por acá...",
  you_did_not_do_any_search_yet: "Aún no realizaste ninguna búsqueda",
  live_search_empty_filtered: "No hay resultados para los filtros aplicados",
  live_search_status_count_error: "Hubo un error al buscar la cantidad de estados de los articulos",
  live_search_new_processed_count: "Nuevos resultados disponibles",
  live_search_processed_count_error: "Hubo un error mientras buscabamos los articulos procesados, por favor intenta luego",
  loading: "Cargando...",
  loading_publications: "Buscando publicaciones...",
  loading_articles: "Cargando artículos",
  loading_brands: "Cargando marcas...",
  loading_live_searches: "Cargando Livesearches",
  loading_portals: "Cargando portales",
  loading_results: "Cargando Resultados",
  login: "Iniciar Sesión",
  loging_in: "Ingresando...",
  recover_password: "Recuperar contraseña",
  contact: "Contacto",
  login_welcome_message: "Ingresa con el usuario y contraseña de la nueva herramienta de denuncias",
  logout: "Cerrar sesión",
  enroll_rights: "Adherir derechos",
  new_profile: "Nuevo perfil",
  change_profile: "Cambiar perfil",
  create_profile: "Crear",
  select_profile: "Seleccionar perfil",
  create_profile_success: "Has creado el perfil de manera exitosa",
  create_profile_error: "Hubo un error cuando creabamos el perfil",
  change_profile_success: "Tu perfil fue cambiado con exito.",
  fetch_profiles_error: "Hubo un error cuando buscabamos los perfiles disponibles",
  change_profile_error: "Hubo un error mientras cambiabamos de perfil, por favor intentalo luego",
  no_profiles: "No hay perfiles disponibles",
  create_account: "Crear cuenta",
  lower_than: "menor que",
  other_sales_conditions: "Todas las condiciones de venta",
  mercadolibre: "Mercado Libre",
  money_saved: "Volumen salvado",
  new_live_search: "Nueva Livesearch",
  new_search: "Nueva Búsqueda",
  new_product: "Producto nuevo",
  new_product_up: "Nuevo",
  refurbished_product: "Producto Reacondicionado",
  next: "Siguiente",
  no_data: "N/D",
  optional: "opcional",
  password: "Contraseña",
  create_user_password: "Clave",
  pending: "pendiente",
  phone: "Tel",
  placeholder_avoided_keywords: "Agrega aquí las palabras a evitar",
  placeholder_required_keywords: "Agrega aquí las palabras requeridas",
  previous: "Anterior",
  price: "Precio",
  price_range: "Rango de precios",
  prices_larger_than_currency: "Precios mayores que",
  prices_smaller_than_currency: "Precios menores que",
  quebarato: "Que Barato",
  refine_search_in_sites: "Refinar Búsqueda en Portales",
  remember_me: "Recordarme",
  repeat_password: "Repetir clave",
  report_label: "Marcar como sospechosa",
  report_label_plural: "Marcar como sospechosas",
  edit_report_label: "Guardar cambios",
  report_article_error: "Lo lamentamos, pero no pudimos enviar la denuncia del artículo. Por favor, intenta nuevamente.",
  report_article_undo_error: "Lo lamentamos, pero no pudimos deshacer. Por favor, intenta nuevamente.",
  report_code: "Infracción",
  report_code_2: "Motivo de Denuncia",
  report_description_label: "Más comentarios",
  report_description: "Descripción de la denuncia",
  report_description_2: "Descripcion Complementaria de Denuncia",
  report_placeholder: "Escribe aquí tus comentarios sobre la publicación que estás por reportar (opcional).",
  report_to_marketplace: "Reportar a Portal",
  report_status_takedown_submitted: "Denuncia enviada",
  report_status_listing_removed: "Artículo removido",
  report_status_takedown_failed: "Fallo denuncia",
  reported_article: "Artículo denunciado",
  reported_to_site: "Reportado al Portal",
  reports: "Denuncias",
  reports_uppercase: "DENUNCIAS",
  reported_by: "Reportado por",
  reputation_excelent: "Excelente",
  reputation_bad: "Mala",
  reputation_good: "Buena",
  reputation_regular: "Regular",
  reputation_unknown: "Desconocida",
  required_words: "Palabras requeridas",
  results_per_page: "Resultados por página",
  screenshoot: "Screenshot al momento de Denuncia",
  search_of_black_sellers_created: "Livesearch de todos los Vendedores Observados creada",
  searches: "Búsquedas",
  searches_uppercase: "BUSQUEDAS",
  selected_articles: "Publicaciones Seleccionadas",
  seller: "Vendedor",
  seller_blacklist: "Observar vendedor",
  black_seller: "Vendedor observado",
  seller_search_create: "Crear livesearch del vendedor",
  seller_search_created: "Livesearch del Vendedor creada",
  seller_white: "Vendedor confiable",
  unset_seller_error: "No pudimos actualizar la informacion del vendedor, por favor intenta mas tarde",
  sellers: "Vendedores",
  sellers_black: "Vendedores observados",
  sellers_white: "Vendedores confiables",
  send_me_reset_password_instructions: "Enviarme instrucciones para resetear la clave",
  sending_report: "Enviando denuncia",
  settings: "Configuración",
  profile: "Perfil",
  show_current_listing: "Mostrar Livesearch del Vendedor",
  enter: "Ingresar",
  entering: "Ingresando",
  sign_in: "Iniciar Sesión",
  signing_in: "Iniciando sesion",
  sign_up: "Registrarse",
  site: "sitio",
  site_reputation: "Reputación",
  hello: "Hola",
  not_found: "Parece que esta página no existe",
  initial_page: "Ir a la página inicial",
  authorize_sites: "Vincular países",
  authorized_site_message:
    "Vincula todas las cuentas que usas en Brand Protection Program, para denunciar en todos los países a la vez. Solo necesitarás ingresar el usuario y contraseña de cada país.",
  authorized_site_title: "Vimos que tienes permisos para denunciar en más países",
  authorized: "Autorizado",
  "new-authorize": "Nuevo",
  authorized_country: "¡Listo! Vinculaste la cuenta de",
  link_other_countries: "Vincular otros países",
  linked: "Vinculado",
  link: "Vincular",
  authorize_site_error: "Ocurrió un error mientras autorizabamos el sitio, por favor vuelve a intentarlo más tarde.",
  authorize_site_error_not_pppi:
    "El usuario con el que estás intentando autenticar no tiene permisos de denuncia, intenta desloguearte en Mercado Libre y volver a intentarlo con el usuario correcto.",
  incorrect_site_authentication:
    "Ha intentado loguearse con un usuario que no pertenece al país que seleccionó. Debe desloguearse en Mercado Libre de dicho país y volver a intentarlo con un usuario correspondiente.",
  authorize_different_account: "Ha intentado loguearse con un usuario que no pertenece a su account.",
  go_to_main_page: "Empezar a denunciar",
  start_reporting: "Empezar a denunciar",
  sold: "ventas",
  sold_quantity: "vendidos",
  sort_by: "Ordenar por",
  start_live_search: "Procesar búsqueda",
  "dont-repeat-livesearch": "No puede haber livesearches repetidos",
  status: "Estado",
  adding_reported_articles: "Agregando Publicaciones Sospechosas...",
  add_reported_articles_by_xlsx: "Agregar Publicaciones Sospechosas desde Excel",
  submit_all_reported_articles: "Enviar todas las denuncias",
  submit_selected_reported_articles_s: "Enviar {10} denuncia",
  submit_selected_reported_articles_p: "Enviar {10} denuncias",
  submit_all_reported_articles_tooltip_pending_cn: "No puedes enviar denuncias hasta que revises tus respuestas pendientes.",
  submit_all_reported_articles_tooltip_restricted: "Restringimos tus denuncias mientras analizamos que se correspondan con tus derechos adheridos.",
  submit_all_reported_ready: "¡Listo! Ya enviamos tus denuncias.",
  submit_one_reported_ready: "¡Listo! Ya enviamos tu denuncia.",
  submit_all_reported_ready_multiple_denounce: "¡Listo! Para gestionar y enviar tus denuncias, ve a la sección Publicaciones sospechosas.",
  submit_one_reported_ready_multiple_denounce: "¡Listo! Para gestionar y enviar tus denuncias, ve a la sección Publicaciones sospechosas.",
  submit_multiple_denounce_send_ready: "¡Listo! Denunciaste los productos.",
  filter_text: "Filtrar y ordenar",
  filter_text_2: "Filtrar",
  filter_modal: {
    filter_1: "Ordenar por",
    filter_2: "Motivo de denuncia",
    filter_3: "País",
    filter_4: "Por Estado",
    apply: "Aplicar filtros",
    apply_2: "Aplicar",
    clean: "Limpiar filtros",
    filter_1_text_1: "Reportes más recientes",
    filter_1_text_2: "Reportes más antiguos",
    all_reasons: "Todos los motivos de denuncia",
  },
  send: "Enviar",
  delete: "Eliminar",
  select_notices: "Selecciona denuncias para accionar masivamente",
  selected_notices_s: "{10} seleccionada",
  selected_notices_p: "{10} seleccionadas",
  select_page: "Seleccionar esta página",
  search_text: "Buscar por # o título",
  select_all: "Seleccionar todos",
  selected_notices_s: "Tienes {10} denuncia seleccionada",
  selected_notices_p: "Tienes {10} denuncias seleccionadas",
  select_page: "Seleccionar esta página",
  unselect_all: "Deseleccionar todos",
  unselect_page: "Deseleccionar esta página",
  clean_all_inactive_btn: "Limpiar inactivas",
  clean_one_inactive_btn: "Limpiar inactiva",
  clean_notices: "Eliminar denuncias",
  clean_selected: "Eliminar denuncias seleccionadas",
  filters_applied: "Filtros aplicados",
  clean_all: "Eliminar todas las denuncias",
  clean_inactive: "Eliminar publicaciones inactivas",
  clean_all_inactive_ready: "¡Listo! Eliminamos tus denuncias",
  clean_one_inactive_ready: "¡Listo! Eliminamos tu denuncia",
  submit_report: "Enviar denuncia",
  submit_report_2: "Solicitar denuncia",
  edit_report: "Editar denuncia",
  submit_reported_articles: "Enviar denuncias",
  create_live_search_current_listings: "Crear Livesearch de los vendedores observados",
  questions_and_answers: "PREGUNTAS Y RESPUESTAS",
  fetch_questions_and_answers_error: "Hubo un error obteniendo las preguntas y respuestas.",
  support_form: {
    title: "Soporte",
    subtitle: "Desde aquí te ayudaremos a resolver todas tus dudas sobre el Brand Protection Program.",
    textarea_label: "Ingresa tu consulta",
    textarea_placeholder: "¿Con qué podemos ayudarte?",
    send_to: "Te responderemos a",
    submit: "Enviar consulta",
    success_modal_title: "¡Recibimos tu consulta!",
    success_modal_will_respond: "Te responderemos por e-mail dentro de las próximas 48 horas.",
    success_modal_cx_number: "Tu número de consulta es ",
    success_modal_understood: "Entendido",
    error_message: "No pudimos enviar tu consulta. Inténtalo de nuevo.",
  },
  support: {
    title: "Contenidos de ayuda",
    "contents-steps": {
      "sug-1-1": "Publicaciones Sugeridas",
      "sug-1-2": "Estadísticas",
      "sug-1-3": "Evolución semanal",
      "sug-1-4": "Pincheta o Apilable",
      "1-1": "Realizar una búsqueda",
      "1-2": "Cómo realizar una búsqueda",
      "1-3": "Filtros de búsqueda",
      "1-4": "Detalle de la publicación",
      "2-1": "Evaluar una publicación",
      "2-2": "Validar como sospechosa una publicación",
      "3-1": "Selección múltiple",
      "3-2": "Como sospechoso",
      "3-3": "Como confiable",
      "4-1": "Publicaciones sospechosas por denunciar",
      "4-2": "Gestión de artículos por denunciar",
      "8-1": "Publicaciones de catálogo",
      "8-2": "¿Qué es una publicación de catálogo?",
      "8-3": "Cómo explorar los vendedores participantes",
      "8-4": "Qué datos define el vendedor",
      "8-5": "Quién responde las preguntas de los compradores",
      "8-6": "Cómo denunciar una publicación de catálogo",
      "5-1": "Evaluar vendedores",
      "5-2": "Cómo evaluar vendedores",
      "5-3": "Cómo ver todos los vendedores confiables u observados",
      "6-1": "Gestión de denuncias",
      "6-2": "Denuncias pendientes",
      "7-1": "Adherir nuevos derechos",
      "7-2": "Cómo adherir nuevos derechos",
    },
    "answer-steps": {
      "sug-1-1": "En esta sección verás las publicaciones que encontramos en base a nuestras detecciones y tu historial de denuncias.",
      "sug-1-image": "01_Esp_captura_suger.png",
      "sug-2-1": "Este complemento tiene con el objetivo de tener visible las publicaciones sospechosas listas para denunciar.",
      "sug-2-2a": "El accionable ",
      "sug-2-2b": "'Denunciar' ",
      "sug-2-2c": "lo direcciona directamente a ",
      "sug-2-2d": "'Publicaciones sospechosas por denunciar'",
      "sug-3-1": "Acá encontrás una breve reseña de su trabajo cumplido y que podrás visualizar tu evolución en tu última semana.",
      "sug-3-2":
        "Los valores que también se muestran son la cantidad de items marcadas como sospechosas y confiables en la última semana. Ten en cuenta que estos valores son tomados sólo de los items sugeridos por Mercado Libre.",
      "sug-3-3":
        "El gráfico muestra el flujo de las denuncias diarias en la última semana. Posando el mouse sobre el gráfico te mostrará el valor del día en particular seleccionado.",
      "sug-3-4":
        "El porcentaje en el marcador verde mostrará si creciste con tu número de denuncias en esta sección y en rojo si has disminuido en comparación a la semana anterior.",
      "sug-2-image": "02_Esp_captura_suger.png",
      "sug-3-2a": "Esta función te permite ",
      "sug-3-2b": "fijar elementos en los primeros resultados ",
      "sug-3-2c":
        "para luego accionar o no perderlos de vista. También da la posibilidad de hacer un barrido rápido de lo que te sugerimos e ir apilando para luego centrarte en el análisis con más criterio.",
      "sug-3-image": "03_Esp_captura_suger.png",
      "1-1p1a": "En esta sección podrás realizar búsquedas de publicaciones por ",
      "1-1p1b": "país* ",
      "1-1p1c": "utilizando diferentes ",
      "1-1p1d": "criterios de búsqueda: ",
      "1-1p2t": "- Nombre de la publicación",
      "1-1p2": "Busca utilizando palabras clave relacionadas con tu marca o derechos adheridos.",
      "1-1p3t": "- ID de la publicación",
      "1-1p3": "Es el número que identifica de forma única cada publicación en Mercado Libre.",
      "1-1p4t": "- Nombre del vendedor",
      "1-1p4": "Es el apodo del vendedor dentro de Mercado Libre.",
      "1-1p5t": "- URL de la publicación",
      "1-1p5": "Es el enlace directo a una publicación.",
      "1-1-clarification": "* Recuerda que puedes realizar búsquedas solo en aquellos países que tengas adheridos.",
      "1-1-image": "04_Esp_captura_suger.png",
      "1-2-1p1a": "En el menú izquierdo elige ",
      "1-2-1p1b": "Búsquedas.",
      "1-2-2": "Selecciona el criterio de búsqueda que vas a utilizar y completa el campo de búsqueda.",
      "1-2-3a": "Indica el país en el que quieres buscar publicaciones. Por defecto buscará en ",
      "1-2-3b": "Argentina",
      "1-2-3c": ", pero tendrá la posibilidad de cambiar de país si así lo deseas.",
      "1-2-4a": "Inicia la búsqueda haciendo clic en ",
      "1-2-4b": "Buscar.",
      "1-3a":
        "Una vez dentro del listado de publicaciones, puedes modificar los filtros de búsqueda para refinar los resultados. Para hacerlo, haz clic en el ",
      "1-3b": "ícono de flecha ",
      "1-3c": "arriba a la izquierda y se desplegará un listado con todos los filtros disponibles.",
      "1-2-image": "05_Esp_captura_suger.png",
      "1-3-1-title": "Precio",
      "1-3-1-text": "Define el rango de búsqueda por precio mínimo y máximo de los productos.",
      "1-3-2-title": "Condición",
      "1-3-2-text": "Si es un producto nuevo o usado.",
      "1-3-3-title": "Categorías",
      "1-3-3-text": "Permite filtrar según las categorías de publicaciones dentro del sitio.",
      "1-3-4-title": "Vendedores observados",
      "1-3-4-text": "Aplica la búsqueda sobre todos los vendedores que marcaste como observados.",
      "1-3-7a": "Luego de aplicar los filtros, haz clic en ",
      "1-3-7b": "Aplicar y buscar.",
      "1-3-8": "* Recuerda que puedes combinar los filtros para mejorar la calidad de los resultados.",
      "1-4":
        "En la pantalla de resultados, haz clic en un producto para ver su detalle. Ahí podrás ver la información de la publicación, los datos y reputación del vendedor, así como también el precio y fotos del producto.",
      "1-3-image": "06_Esp_captura_suger.png",
      "2-1": "Validar una publicación",
      "2-1-1": "Desde el listado de publicaciones",
      "2-1-2a": "Pasa el mouse sobre las publicaciones. Haz clic en los botones SOSPECHOSO y CONFIABLE para validarlos.",
      "2-1-image": "07_Esp_captura_suger.png",
      "2-1-2b":
        "Si eliges el botón CONFIABLE, las publicaciones desaparecerán de los resultados de búsqueda automáticamente. Si eliges el botón SOSPECHOSO, podrás “marcarlo como sospechoso” y colocar el motivo.",
      "2-2-image": "08_Esp_captura_suger.png",
      "2-2-1": "Desde el detalle de la publicación",
      "2-2-1a": "Ahí podrás indicar con el botón CONFIABLE o SOSPECHOSO si consideras que está o no infringiendo alguno de tus derechos adheridos.",
      "2-3-image": "09_Esp_captura_suger.png",
      "2-2-1b":
        "Todos los productos que ya hayas validado como CONFIABLES o SOSPECHOSOS serán excluidos automáticamente de tus próximos resultados de búsqueda.",
      "2-3-1": "Validar como sospechosa una publicación",
      "2-3-2": "Si consideras que un artículo está infringiendo uno o más de tus derechos, haz clic en el botón SOSPECHOSO.",
      "2-3-3": "En el menú lateral derecho junto al detalle de la publicación podrás marcar el motivo de denuncia de la publicación.",
      "2-3-4": "Los motivos serán los siguientes.",
      "2-3-4a": "En el producto:",
      "2-3-4a-1": "Producto falsificado",
      "2-3-4a-2": "Infracción de derechos de autor",
      "2-3-4b": "En la publicación:",
      "2-3-4b-1": "Uso ilegítimo de marca registrada",
      "2-3-4b-2": "Uso no autorizado de imágenes de terceros",
      "2-3-4b-3": "Uso no autorizado de imagen personal",
      "2-4-1": "Una vez seleccionado el motivo y hacer clic en ",
      "2-4-2": "'Continuar' ",
      "2-4-3": "podrás agregar un comentario. Luego, haz clic en 'Marcar como sospechosa'.",
      "2-4-image": "10_Esp_captura_suger.png",
      "2-5-1": "Para enviar la denuncia sobre esa publicación, ingresa a la sección de 'Publicaciones sospechosas por denunciar' en el menú lateral izquierdo.",
      "3-1-1": "Este complemento te permite marcar varias publicaciones como ",
      "3-1-2": "'Confiables' o 'Sospechosas' ",
      "3-1-3": "a la vez, de forma ágil y rápida. Ten en cuenta que solo podrás marcar esas publicaciones como sospechosas si comparten el motivo de denuncia.",
      "3-1-image": "11_Esp_captura_suger.png",
      "3-2-1": "Para marcar varias publicaciones como 'Sospechosas'",
      "3-2-2":
        "Haz clic en el botón de 'Selección múltiple' y marca como 'sospechosas' todas las publicaciones que desees seleccionar. Verás que al hacerlo se resaltan en color rojo.",
      "3-2-3": "Toca el botón de 'Aplicar' para marcarlas como sospechosas y continuar la denuncia.",
      "3-2-image": "12_Esp_captura_suger.png",
      "3-3-1": "Para marcar varias publicaciones como 'Confiables'",
      "3-3-2":
        "Haz clic en el botón de 'Selección múltiple' y marca como 'confiable' todas las publicaciones que desees seleccionar. Verás que al hacerlo se resaltan en color verde.",
      "3-3-3": "Toca el botón de 'Aplicar' para que desaparezcan del listado de búsqueda.",
      "3-3-image": "13_Esp_captura_suger.png",
      "4-1-1": "Gestión de artículos por denunciar",
      "4-1-2":
        "En el menú de la izquierda en las sección 'Publicaciones sospechosas por denunciar' encontrarás todas las publicaciones que marcaste como posibles infractoras, pero que todavía no denunciaste.",
      "4-1-image": "14_Esp_captura_suger.png",
      "4-2-1": "Confirmar denuncia",
      "4-2-2a": "Si estás seguro de que quieres denunciar la publicación, haz clic en ",
      "4-2-2b": "'Enviar denuncia'. ",
      "4-2-2c": "Para enviar todas las denuncias al mismo tiempo, puedes hacerlo haciendo clic en ",
      "4-2-2d": "'Enviar todas las denuncias'.",
      "4-3-1": "Cancelar denuncia",
      "4-3-2": "Si deseas cancelar la denuncia, haz clic en ",
      "4-3-3": "'Desestimar'",
      "4-4-1": "Revisar detalle",
      "4-4-2": "Si quieres revisar el detalle de la denuncia, haz clic en el ícono '+'.",
      "4-5-1": "Editar motivo de denuncia",
      "4-5-2a": "Si quieres cambiar el motivo de denuncia haz clic en el botón ",
      "4-5-2b": "'Editar'",
      "4-5-2c": "y sigue los pasos para colocar el nuevo motivo.",
      "5-1-1": "En esta sección puedes ver todos los vendedores que colocaste bajo observación y a los que consideras confiables.",
      "5-1-image": "15_Esp_captura_suger.png",
      "5-2-1": "Cómo evaluar vendedores",
      "5-2-2": "En la vista de detalle de la publicación, verás tres botones que te permitirán evaluar vendedores.",
      "5-3-1": "Vendedor observado",
      "5-3-2":
        "Le agrega un banderín negro al vendedor. Una vez que identificas a un vendedor como bajo observación, sus productos aparecerán destacados en tus búsquedas para que puedas identificarlos más fácilmente.",
      "5-2-image": "16_Esp_captura_suger.png",
      "5-4-1": "Vendedor confiable",
      "5-4-2":
        "Cuando marcas al vendedor como confiable se agregará automáticamente al listado de vendedores confiables y sus publicaciones serán excluidas de los resultados de búsqueda.",
      "5-5-1": "Crear livesearch del vendedor",
      "5-5-2a": "Crea una ",
      "5-5-2b": "'Búsqueda guardada' ",
      "5-5-2c":
        "del vendedor y de la categoría del producto para que puedas revisarlas más tarde. Puedes acceder a ella desde el menú de la izquierda, en Búsquedas.",
      "5-6-1": "Vendedores observados",
      "5-6-2":
        "En el detalle de la publicación, haz clic en el ícono de la lupa al lado del nombre del vendedor. Así verás a todos los vendedores que marcaste bajo observación en tus búsquedas.",
      "5-6-3a": "Puedes acceder a ese listado desde el menú de la izquierda, en ",
      "5-6-3b": "Vendedores > Vendedores observados.",
      "5-3-image": "17_Esp_captura_suger.png",
      "5-6-4":
        "La tabla muestra el país en el que opera cada vendedor observado, así como su nombre de usuario en Mercado Libre, la cantidad de reportes recibidos y la cantidad de productos en su listado de ventas.",
      "5-7-1": "Para revisar todos los artículos de vendedores observados",
      "5-7-2a": "Primero haz clic en ",
      "5-7-2b": "'Crear una nueva livesearch'",
      "5-7-2c": "dentro de la tabla. Esa búsqueda quedará guardada en la sección 'Búsquedas'.",
      "5-4-image": "18_Esp_captura_suger.png",
      "5-8-1": "Vendedores confiables",
      "5-8-2": "Aquí verás a todos los vendedores que marcaste como confiables en tus búsquedas.",
      "5-8-3a": "Puedes acceder a ella desde el menú de la izquierda, en ",
      "5-8-3b": "Vendedores > Vendedores confiables.",
      "5-5-image": "19_Esp_captura_suger.png",
      "5-8-4": "La tabla muestra el país en el que opera el vendedor, su nombre usuario en Mercado Libre, y la cantidad de productos en su listado de ventas.",
      "5-9-1": "Para revisar todos los artículos de vendedores observados",
      "5-9-2a": "Primero debemos hacer clic en ",
      "5-9-2b": "'Crear una nueva livesearch' ",
      "5-9-2c": "dentro de la tabla. Esa búsqueda quedará guardada en la sección 'Búsquedas'.",
      "6-1-1": "Aquí podrás seguir el estado de tus denuncias y responder a los vendedores para decidir si quieres confirmar o retractar tu denuncia.",
      "6-1-image": "20_Esp_captura_suger.png",
      "6-2-1": "Muestra una tabla con todas las denuncias que tienes abiertas. Haz clic en cualquiera de tus denuncias para ver sus detalles.",
      "6-2-2-title": "Respuesta del vendedor",
      "6-2-2-text": "Muestra la fecha en que el vendedor envió la respuesta a tu denuncia, junto con sus notas y archivos adjuntos.",
      "6-2-3-title": "Denuncia",
      "6-2-3-text": "Muestra la fecha en que se realizó la denuncia de la publicación, el nombre del auditor y el código único de la denuncia.",
      "6-2-4-title": "Publicación",
      "6-2-4-text": "Es una captura de la publicación tal y como se veía el día en que se realizó la denuncia.",
      "6-2-5-title": "Datos Vendedor",
      "6-2-5-text":
        "Aquí verás la información del vendedor que publicó el producto que denunciaste, como su reputación en Mercado Libre, cantidad de denuncias enviadas, counter notices recibidos y aceptados.",
      "6-2-6":
        "Si consideras que la respuesta es suficiente y quieres dar de baja tu denuncia, selecciona el pulgar para arriba. Por el contrario, si la respuesta no te parece suficiente, selecciona el pulgar abajo.",
      "6-3-1": "Respuesta del vendedor",
      "6-3-2a": "Desde este bloque tendrás la posibilidad de ",
      "6-3-2b": "'Confirmar o rechazar la denuncia' ",
      "6-3-2c": "y dejar un comentario para enviarle al vendedor.",
      "6-4-1": "En caso de rechazar la denuncia, deberás seleccionar el motivo.",
      "6-2-image": "21_Esp_captura_suger.png",
      "7-2-1": "Si necesitas sumar nuevos derechos para poder realizar más y mejores denuncias, ",
      "7-2-1b": "haz clic aquí.",
      "7-2-2-title": "En la pantalla de adhesión de derechos",
      "7-2-2-text":
        "Selecciona la casilla de verificación del derecho que quieras añadir. Si necesitas adherir más de uno, puedes seleccionar múltiples opciones.",
      "7-2-3":
        "Aparecerá un recuadro blanco en la parte inferior de la pantalla por cada tipo de derecho que hayas seleccionado. Adjunta la documentación requerida para cada caso.",
      "7-2-4": "Cuando hayas terminado, haz clic en el botón ",
      "7-2-5": "Enviar documentación.",
      "7-2-6": "¡Listo! Nuestros representantes analizarán tu documentación y te notificarán por e-mail del estado de tu solicitud.",
      "8-1-1": "Publicaciones de catálogo",
      "8-2-1": "¿Qué es una publicación de catálogo?",
      "8-2-2": "Se trata de una “página de producto” que agrupa, bajo un único contenido, varias publicaciones ofrecidas por diferentes vendedores.",
      "8-2-3":
        "Las publicaciones de los vendedores compiten por ser la primera opción que ven los compradores. Quien ofrezca las mejores condiciones de venta y experiencia será el 'Ganador'. La competencia se basa, entre otras cosas, en el precio, la reputación del vendedor y las condiciones de venta ofrecidas.",
      "8-3-1": "Cómo explorar los vendedores participantes",
      "8-3-2":
        "Ten en cuenta que las “páginas de producto” tienen variantes. Por ejemplo, para un celular se muestran las distintas capacidades y colores disponibles. Para cada combinación de las variantes, puede haber un ganador distinto.",
      "8-3-3":
        "Al encontrar una publicación de catálogo en la herramienta de denuncias, podrás ir al detalle de la publicación para conocer los vendedores participantes para cada variante.",
      "8-3-image": "22_Esp_captura_Suger.png",
      "8-4-1": "Qué datos define el vendedor",
      "8-4-2":
        "El vendedor configura las condiciones particulares de la publicación participante en “Catálogo”. Esto incluye precio, stock, garantía y forma de envío.",
      "8-5-image": "23_Esp_captura_Suger.png",
      "8-5-1": "Quién responde las preguntas de los compradores",
      "8-5-2": "En una publicación de catálogo las respuestas a las preguntas de los compradores las da el vendedor ganador del momento.",
      "8-5-3": "En la columna de “Vendedores participantes” podrás ver las respuesta que ha dado cada vendedor con solo seleccionarlo.",
      "8-6-1": "Conocer más sobre Publicaciones de catálogo",
      "8-7-1": "Cómo denunciar una publicación de catálogo",
      "8-7-1-a": "Para denunciar las fotos de la publicación,",
      "8-7-1-b": " selecciona la opción “Marcar como sospechosa” en la sección que muestra los detalles del producto.",
      "8-7-image": "24_Esp_captura_Suger.png",
      "8-7-2-a": "Para reportar la publicación de un vendedor,",
      "8-7-2-b": "explora la columna “Vendedores participantes” y toca el botón “ Marcar como sospechosa”.",
      "8-7-2-image": "25_Esp_captura_Suger.png",
      "8-8-1": "Las publicaciones que marques como sospechosas aparecerán en la sección ",
      "8-8-1-a": "“Denuncias sospechosas por denunciar”",
      "8-8-1-b": "y podrás gestionarlas como lo haces normalmente.",
    },
    "question-platform": "Cómo se utiliza la Plataforma de Protección de Marcas",
    "answer-platform":
      "Con esta herramienta puedes buscar las publicaciones relacionadas a tu marca en todos los países donde tengas derecho de denuncia. A diferencia de utilizar los sitios de cada país de Mercado Libre para auditar infracciones, con esta plataforma puedes gestionar publicaciones de todos los países en un único lugar.",
    "question-livesearch": "¿Qué es un Livesearch?",
    "answer-livesearch":
      "Livesearch son las búsquedas de publicaciones a partir de una o más palabras claves. Puedes hacer tus búsquedas por país o en varios a la vez, siempre que estés autorizado para denunciar en más de un país. Es importante que las palabras que uses estén relacionadas con la marca que auditas, así puedes obtener resultados muchos más exactos.",
    steps: {
      "1-1": "En el menú izquierdo elige Búsquedas",
      "2-1": "Ingresa las palabras claves y haz click en",
      "2-2": "Buscar",
      "3-1": "Indica los países en los que quieres y elige",
      "3-2": "Procesar Búsqueda",
      "4-1":
        "Cuando inicie el proceso de livesearch verás la cantidad de publicaciones que existen para las palabras claves que ingresaste. Si haces click en la o las palabra clave que figuran en el livesearch puedes comenzar a revisar las publicaciones. Puede comenzar a auditar aunque la búsqueda aún esté en proceso.",
    },
    "question-grid": "Grilla de resultados",
    "answer-grid":
      "En la vista de grilla de resultado vas a encontrar todas las publicaciones que coincidieron con las palabras claves que usaste en tu livesearch.",
    "question-filter-liversearch": "Filtros del Livesearch",
    "answer-filter-liversearch1":
      "Una vez que obtuviste los resultados en, puedes ajustar la búsqueda y hacerla mucho más precisa usando los filtros. Puedes usarlos de a uno o combinarlos como prefieras.",
    "answer-filter-liversearch2":
      "Podrás concentrar tu búsqueda sólo una línea de productos de tu marca, o filtrar por fecha de publicación, precio, stock, etc. De la misma forma, podrás excluir palabras de los resultados.",
    "question-publication": "Vista detalle de publicación",
    "answer-publication":
      "Para acceder a la vista de detalle debes hacer click en una publicación en la grilla de resultados. En la vista de detalle obtendrás mayor información del artículo ofrecido, sus fotos, información del vendedor y análisis de stock y ventas actuales.",
    "question-publication-valid": "Pulgar para arriba",
    "answer-publication-valid":
      "Si ves que una publicación no está cometiendo ninguna infracción a tu marca, indica con el pulgar para arriba que la publicación es válida. De esta forma, en el futuras busquedas esa publicación no volverá a aparecer en los resultados que hagas.",
    "question-publication-invalid": "Pulgar para abajo",
    "answer-publication-invalid1":
      "Si ves que una publicación está cometiendo una o más infracciones de propiedad intelectual, debes marcarla con el pulgar para abajo. Luego se abrirá un cuadro en el que podrás agregar más detalles con respecto a la o las infracciones que detectaste.",
    "answer-publication-invalid2": "Tags",
    "answer-publication-invalid2-1":
      "Los tags son etiquetas de referencia que podrás usar luego para emitir reportes. Estas etiquetas o descripciones son solo de uso interno, y no figuran en la denuncia formal.",
    "answer-publication-invalid3": "Código de denuncia",
    "answer-publication-invalid3-1":
      "Es el código asociado al motivo de tu denuncia. Esto está relacionado con los derechos que adheriste al Brand Protection Program para denunciar en Mercado Libre.",
    "answer-publication-invalid4": "Detalle",
    "answer-publication-invalid4-1":
      "Puedes agregar un detalle del motivo de tu denuncia que estás por realizar. Esto será de ayuda por si algún miembro del equipo necesita más información antes de procesar una baja.",
    "answer-publication-invalid5": "Denunciar",
    "answer-publication-invalid5-1":
      "Una vez que tocas en denunciar, la denuncia aún no será procesada y enviada al equipo de revisión de Brand Protection Program, sino que será enviada a Artículos por denunciar junto con las otras denuncias que hayas realizado. Por lo tanto, si identificas que esta denuncia fue mal realizada, podrás eliminarla luego.",
    "answer-publication-invalid6": "Artículos por denunciar",
    "answer-publication-invalid6-1":
      "Aquí estarán todas las publicaciones que marcaste con el pulgar para abajo. En esta instancia es donde efectivamente denunciarás las publicaciones. Por eso, es  recomendable revisar todos los detalles que antes completaste, para asegurarte de las infracciones. Si quieres también puedes visitar la publicacion en Mercado Libre, haciendo click en el siguiente botón.",
    "answer-publication-invalid6-2": "Si haces click en (+) podrás ver los detalles de tu denuncia.",
    "answer-publication-invalid6-3":
      "Si encuentras que una publicación no está en infracción, puedes elegir Quitar de la lista y no será realizada la denuncia.",
    "answer-publication-invalid6-4":
      "Una vez que estés seguro que quieres enviar las denuncias, puedes enviarlas individualmente o hacerlo de forma masiva y elegir Enviar todas las denuncias.",
    "question-whitelistsellers": "Vendedores confiables",
    "answer-whitelistsellers1":
      "Puedes identificar vendedores como confiables (por ej. Tiendas Oficiales, distribuidores, etc) para que sus publicaciones dejen de salir en tus livesearch y de esa forma no perder tiempo auditandolas y haciendo análisis.",
    "answer-whitelistsellers2": "Para identificarlo debes abrir la vista detalle y hacer click en ",
    "answer-whitelistsellers3": " Vendedor confiable.",
    "question-blacklistsellers": "Vendedores Observados",
    "answer-blacklistsellers1":
      "Si crees que es necesarios hacer seguimiento de algunos vendedores y de todas sus publicaciones, debes elegir Observar vendedor.",
    "answer-blacklistsellers2":
      "Todas las publicaciones de este vendedor estarán marcadas con banderita negra. También podrás filtrar los resultados para que muestren sólo publicaciones de vendedores observados.",
    "answer-blacklistsellers3-1": "Puedes ver la actividad de publicaciones y denuncias de estos vendedores en el menú a la izquierda, en la sección ",
    "answer-blacklistsellers3-2": "Vendedores > Vendedores Observados",
    "question-livesearch-sellers": "Livesearches de Vendedores",
    "answer-livesearch-sellers-1":
      "Ya sea desde la vista detalle, en las secciones de Vendedores observados o desde Vendedores confiables, puedes crear un Livesearch para observar todas las publicaciones de estos vendedores.",
    "answer-livesearch-sellers-2":
      "Cuando identificas al menos una publicación que infringe los derechos de tu marca, es recomendable analizar todas sus publicaciones del vendedor para identificar si tiene más que puedan afectar a tu marca.",
    "question-post-denunciation": "Seguimiento post-denuncia",
    "answer-post-denunciation1-1":
      "Podrás generar reportes de tu actividad y exportarlo un archivo Excel. Podrás hacer seguimiento de todo el trabajo de auditoría.",
    "answer-post-denunciation1-2":
      "También podrás ver todas las publicaciones denunciadas fueron dadas de baja. También podrás ver una foto de referencia de la publicación al momento de hacer la denuncia.",
    "question-counter-notice": "Counter Notice",
    "answer-counter-notice1":
      "Si un vendedor realiza un counter notice a una denuncia, llegará al e-mail que marcaste como e-mail del contacto al registrar tus derechos en Brand Protection Program. Este e-mail corresponde al asociado a las cuentas de denuncia de Brand Protection Program en cada país.",
    "answer-counter-notice2": "Recuerda que ese e-mail es distinto que el que registraste como auditor para denunciar en esta plataforma.",
    disclaimer: "* Las imágenes se muestran a modo de ejemplo para explicar el uso de la herramienta.",
    "question-support": "SOPORTE",
    "see-more": "Aún tienes una duda?, podemos ayudarte.",
    "goto-support": "Ir a Soporte",
  },
  black_sellers: {
    ID: "ID",
    title: "Ultimos vededores observados",
    placeholder_sites: "Seleccione vendedor",
    table_th_sitie: "SITIO",
    table_th_country: "PAÍS",
    table_th_sellers: "VENDEDOR",
    table_th_reports: "DENUNCIAS RECIBIDAS",
    table_th_actions: "ACCIONES",
    table_th_current_listings: "PUBLICACIONES ACTIVAS",
    empty_sellers_message: "No hay Vendedores Observados disponibles.",
    button_create_current_listings: "Crear livesearch con publicaciones actuales",
    button_delete_current_listings: "Eliminar",
    confirm_delete_client_black_seller: "Estás seguro que deseas eliminar a este Vendedor de la lista de Vendedores Observados?",
    black_list_seller_deleted: "Vendedor Observados eliminado",
    black_list_seller_delete_error: "Hubo un problema mientras intentabamos eliminar a este vendedor. por favor intenta luego",
    fetch_black_list_seller_error: "Lo lamentamos, hubo un error en la búsqueda de vendedores",
  },
  case_management: {
    cases: {
      pending_title: "Denuncias por responder",
      pending_table_explanation: "Los siguientes vendedores han enviado un Counter-Notice a tus solicitudes de baja de publicación",
      search: "Buscar",
      table_th_auditor: "Auditor",
      table_th_country: "País",
      table_th_id: "ID",
      table_th_article: "Publicación",
      table_th_sellers: "Vendedor",
      table_th_status: "Estado",
      table_th_denounce: "Fecha de Denuncia",
      table_th_denounce_2: "Fecha de denuncia:",
      table_th_denounce_sent: "Fecha de Denuncia",
      table_th_counter_notice: "Fecha de Respuesta",
      table_th_response_limit: "Plazo de Respuesta",
      empty_cases_message: "No se encontraron resultados",
      fetch_pending_cases_list_error: "Lo sentimos, hubo un error en la búsqueda de casos",
      denounced_date: "Denunciada: ",
      updated_date: "Actualizada: ",
      canceled_date: "Dada de baja: ",
      dates: "Ver fechas",
    },
    case_description: {
      denounced_seller: "Vendedor denunciado",
      seller_response: "Esto es lo que te escribió",
      seller_empty_response: "El vendedor no escribió comentarios",
      photos_current: "Estas son las imágenes actuales de la publicación",
      photos_modified_new: "NUEVA",
      photos_denounced: "Estas son las imágenes que reportaste",
      fetch_description_denounces_error: "Lo sentimos, hubo un error al buscar los datos.",
      no_data_found: "No se encontraron datos",
      "counter-notice_tab": "Respuesta del vendedor",
      "counter-notice": {
        counter_notice_attached_file: "ARCHIVO ADJUNTO",
      },
      denounce_tab: "Denuncia",
      denounce: {
        denounce_date: "FECHA DE DENUNCIA",
        auditor: "AUDITOR",
        code: "MOTIVO DE DENUNCIA",
        additional_description: "NOTAS DEL AUDITOR",
      },
      publication_tab: "Publicación",
      publication: {
        site: "Mercado Libre",
        price: "PRECIO",
        product_sold_in_this_publication: "PRODUCTOS VENDIDOS EN ESTA PUBLICACIÓN",
        description: "DESCRIPCIÓN",
        images: "fotos",
        image: "foto",
      },
      "seller-data_tab": "Datos Vendedor",
      seller_data: {
        create_seller_LS: "Crear LiveSearch para este Vendedor",
        black_seller: "Vendedor Observado",
        portal_reputation: "Reputación",
        sold_quantity_products: "Cantidad de productos vendidos",
        denonces_sent_to_this_seller: "Denuncias",
        counter_notice_received: "Respuestas enviadas",
        counter_notice_accepted: "Respuestas aceptadas",
        denounces_table_article: "Publicación",
        denounces_table_denounce: "Denuncia",
        denounces_table_status: "Estado",
        denounces_counter_notice: "Respuesta de Vendedor",
        fetch_counter_notices_error: "Hubo un error obteniendo las denuncias del vendedor",
      },
    },
    documentation_approved: {
      sending_response: "Estamos enviando tu respuesta al vendedor.",
      response_placeholder: "Revisé la respuesta y quiero:",
      reject_option_member_placeholder: "Voy a confirmarla porque:",
      approved_case_title: "Respuesta para el vendedor",
      approved_case_title_sent: "Respuesta",
      confirm: "Confirmar mi denuncia",
      retract: "Retractar mi denuncia",
      confirm_helper_text: "Envía esta respuesta para finalizar la publicación.",
      retract_helper_text: "Envía esta respuesta para reactivar la publicación.",
      send_response: "Enviar respuesta",
      reject_option_label: "Motivo de tu decisión",
      description_label: "Comentario adicional",
      no_description: "Sin descripción",
      report_placeholder: "Explícale al vendedor por qué has tomado esta decisión.",
      respond_counter_notice_success_confirm: "La publicación fue eliminada.",
      respond_counter_notice_success_retract: "La publicación fue reactivada.",
      respond_counter_notice_success: "¡Listo! Ya enviamos tu respuesta al vendedor.",
      respond_counter_notice_error: "Lo sentimos, hubo un error.",
      respond_counter_notice_rejected_by_abuse: "La justificación no detalla una infracción. Por eso, reactivamos la publicación.",
      closed_title: "Ya respondiste a este vendedor",
      responded: "Esta fue tu decisión",
      responded_at: "Le respondiste el",
    },
    publication_status: {
      active: "Activa",
      closed: "Finalizada",
      inactive: "Inactiva",
      paused: "Pausada",
      under_review: "Para revisar",
    },
    denounce_status: {
      waiting: "Esperando respuesta",
      pending: "Respondida",
      accepted: "Publicación reactivada",
      not_approved: "Publicación finalizada",
      not_presented: "No respondida",
      not_respond: "Expirada",
      rollback: "Retractada",
      discard_due_restriction: "Descartada",
      pending_moderation: "Pendiente",
      rejected: "Denuncia Rechazada",
      acuerdo_closed: "Publicación finalizada",
      duplicated_denounce: "N/A",
      discarded: "Descartada",
      rejected_modified: "Publicación modificada",
      revision: "Denuncia en revisión",
    },
    denounce_status_V3: {
      approved: "Aprobada",
      in_progress: "En curso",
      pending: "Pendiente por responder",
      rejected: "Rechazada",
      rollback: "Retirada",
      not_respond: "Expirada",
      waiting: "Esperando respuesta",
      discarded: "Descartada",
      rejected_modified: "Publicación modificada",
      dismissed: "Denuncia desestimada",
      listing_reactivated: "Publicación reactivada",
    },
    pending_denounce_widget: {
      title: "Denuncias pendientes por responder.",
      subtitle: "Revisá la respuesta del vendedor.",
    },
    status_pill: {
      expire_days: "Vence en {} días",
      expire_day: "Vence en {} día",
      expire_hours: "Vence en {} horas",
    },
  },
  welcome_page: {
    title: "¡Bienvenido!",
    subtitle: "Estás a un paso de usar la nueva herramienta de denuncias de Mercado Libre",
    no_auditor_boton: "Quiero registrarme",
    enter_now_to_denounce: "Ya estoy registrado",
  },
  welcome_register_page: {
    title: "Bienvenido a la herramienta de denuncias del Brand Protection Program",
    subtitle:
      "Si ya estás registrado en el programa, ingresa con cualquiera de tus usuarios de Brand Protection Program. Si todavía no tienes cuenta, regístrate.",
    subtitle2: "Ingresa el e-mail registrado en el Brand Protection Program",
    email: "E-mail",
    singin_button: "Ingresar",
    continue_button: "Continuar",
    no_account_button: "Registrate aquí",
    know_more: "Conoce más sobre el programa",
  },
  error_no_bpp: {
    title: "No pudimos iniciar sesión",
    subtitlePart1: "Por favor, ingresa de nuevo y ",
    subtitlePart2: "asegúrate de usar tus credenciales del BPP.",
    btn: "Ingresar de nuevo",
  },
  reported_articles: {
    send: "Enviar",
    delete: "Eliminar",
    alerts: {
      cannot_submit_title: "No puedes realizar denuncias",
      cannot_submit_subtitle:
        "Encontramos comportamientos abusivos en tus rechazos a las respuestas de los vendedores y por eso no podrás enviar denuncias temporalmente.",
    },
    filters: {
      placeholder_reference_id: "ID",
      placeholder_title: "Título",
      placeholder_price_from: "Precio desde (USD)",
      placeholder_term: "Título",
      placeholder_site: "Seleccione Sitio",
      placeholder_price_to: "Precio hasta (USD)",
      placeholder_seller: "Seleccione Vendedor",
      placeholder_complaint: "Seleccione Estado",
      placeholder_date_from: "DESDE",
      placeholder_date_to: "HASTA",
      option_selecet_complaint_status_with_error: "Por Enviar",
      option_selecet_complaint_status_without_error: "Error de envio",
    },
    articles_reported: {
      title: "Historial de denuncias",
      description: "Revisá el estado de tus denuncias y asegurate de responder las que estén pendientes.",
      search: "Buscar por ID, nombre del vendedor",
      filter: "Filtrar y ordenar",
      table_th_seller: "Vendedor",
      table_th_denounce: "Publicación denunciada",
      table_th_reason: "Motivo de la denuncia",
      table_th_status: "Estado",
      placeholder_sites: "SELECCIONE SITIO",
      table_th_id: "ID",
      table_th_site: "SITIO",
      table_th_country: "PAÍS",
      table_th_article: "PUBLICACIÓN",
      table_th_auditor: "AUDITOR",
      table_th_price: "PRECIO",
      table_th_reported: "DENUNCIADO",
      table_th_notice_status: "ESTADO",
      table_th_notice_update: "ACTUALIZADO",
      table_th_down: "BAJA",
      reported_at: "FECHA REPORTE",
      button_clear_filters: "Borrar Filtro",
      button_submit_filters: "Buscar",
      empty_reported_articles_message: "No hay artículos reportados disponibles.",
      "": "",
    },
    denounce_status_tooltip: {
      WAITING_DOCUMENTATION: "El vendedor todavía no ha respondido tu denuncia.",
      DOCUMENTATION_PRESENTED: "El vendedor ya ha respondido a tu denuncia.",
      DOCUMENTATION_APPROVED: "Has decidido reactivar esta publicación.",
      DOCUMENTATION_NOT_APPROVED: "Has decidido finalizar esta publicación.",
      DOCUMENTATION_NOT_PRESENTED: "Finalizamos la publicación porque el vendedor no te respondió dentro del plazo.",
      MEMBER_NOT_RESPOND: "No has respondido al vendedor a tiempo y la denuncia ha expirado.",
      ROLLBACK: "Has decidido reactivar la publicación del vendedor porque retractaste tu denuncia.",
      DISCARDED_DUE_RESTRICTION: "El vendedor ya fue inhabilitado, y no es necesario que revises su respuesta.",
      ACUERDO_CLOSED: "Hemos finalizado esta publicación.",
      DUPLICATED_DENOUNCE: "N/A",
      REJECTED: "Tu denuncia fue rechazada.",
      REJECTED_BY_ABUSE: "Tu justificación no detallaba una infraccion de propiedad intelectual. La publicación fue reactivada.",
      REJECTED_BY_ABUSE_COUNTER_NOTICE: "Tu denuncia fue rechazada.",
      DISCARDED: "La publicación ya fue dada de baja.",
      PENDING_MODERATION: "Tu denuncia todavía no fue aprobada.",
      CREATED: "Tu denuncia todavía no fue aprobada.",
      CROSS_DENOUNCE_CLOSED: "Tu denuncia fue rechazada.",
      WAITING_FOR_PATCH_PDP: "Estamos analizando tu denuncia. De ser necesario, haremos los ajustes correspondientes.",
      REJECTED_PDP_CATALOG:
        "No pudimos procesar tu denuncia porque las imágenes que denunciaste fueron obtenidas de un banco privado de imágenes. \n\n Revisa de nuevo la publicación y, si aún consideras que infringe tus derechos, contáctanos desde la sección de soporte",
      REJECTED_PDP_ITEM:
        "No pudimos procesar tu denuncia porque las imágenes que denunciaste las obtuvimos de publicaciones de nuestros vendedores que no habías denunciado. \n\n Revisa de nuevo la publicación y, si aún consideras que infringe tus derechos, contáctanos desde la sección de soporte.",
      REJECTED_PDP_IMAGE_RANKER:
        "No pudimos procesar tu denuncia porque las imágenes que denunciaste fueron obtenidas de un banco de imágenes, que las disponibiliza garantizando que su uso es autorizado, o de publicaciones de nuestros vendedores. \n\n Revisa de nuevo la publicación y, si aún consideras que infringe tus derechos, contáctanos desde la sección de soporte.",
      REJECTED_MODIFIED:
        "La publicación fue modificada luego de tu denuncia. Revísala de nuevo y, si aún consideras que infringe tus derechos, contáctanos desde la sección de soporte",
    },
    denounce_status_tooltipV3: {
      ACUERDO_CLOSED: "La publicación denunciada fue eliminada.",
      DOCUMENTATION_NOT_APPROVED: "La documentacíon del vendedor no fue aprobada.\n\n La publicación denunciada fue eliminada.",
      DOCUMENTATION_NOT_PRESENTED: "Tu denuncia fue aprobada porque el vendedor no presentó la documentación.",
      CREATED: "Tu denuncia está pendiente para ser procesada.",
      PENDING_MODERATION: "Tu denuncia está pendiente para ser procesada.",
      WAITING_DOCUMENTATION: "El vendedor esta pendiente por responder.",
      WAITING_FOR_PATCH_PDP: "Estamos analizando tu denuncia. De ser necesario, haremos los ajustes correspondientes.",
      DOCUMENTATION_PRESENTED: "El vendedor está esperando tu respuesta.Si no contestas la denuncia,esta será anulada.",
      DUPLICATED_DENOUNCE: "Tu denuncia no se puede realizar porque está duplicada.",
      MEMBER_NOT_RESPOND: "Tu denuncia fue rechazada porque no diste respuesta al vendedor en el plazo establecido.",
      REJECTED: "Tu denuncia fue rechazada porque no cumple con los requisitos necesarios.",     
      REJECTED_BY_RESTRICTION: "Superaste el limite de denuncias diarias. Revisa la eficiencia de tu cuenta.",
      REJECTED_BY_ABUSE: "Tu justificación no detallaba una infracción de propiedad intelectual. La publicación fue reactivada.",
      REJECTED_BY_ABUSE_COUNTER_NOTICE: "Tu justificación no detallaba una infracción de propiedad intelectual. La publicación fue reactivada.",
      DOCUMENTATION_APPROVED: "La documentación del vendedor fue aprobada y tu denuncia retirada.",
      ROLLBACK: "Retiraste la denuncia.La publicación denunciada será reactivada.",
      DISCARDED: "Tu denuncia no se puede realizar porque la publicación ya no esta disponible.",
      DISCARDED_DUE_RESTRICTION: "Tu denuncia no se puede realizar porque el vendedor se encuentra inhabilitado.",
      REJECTED_MODIFIED: "Tu denuncia fue descartada porque la publicación fue modificada.",
      REJECTED_PDP_CATALOG: "Tu denuncia fue descartada porque las imágenes que denunciaste fueron obtenidas de un banco privado de imagenes",
    },
    info_cn_message: {
      title: "Ahora tus denuncias se resuelven en menos tiempo",
      description: "El plazo para resolver denuncias ahora es de 6 días: 3 días para que el vendedor responda a tu denuncia y 3 días para que revises su respuesta.",
      description_2: "Contamos todos los días de lunes a sábado, incluso si son feriados, y  ",
      description_2Strong: " no contamos los domingos.",
      description_3: " Por ejemplo: si haces una denuncia un viernes a las 10 hs, el vendedor tendrá tiempo hasta el martes a la misma hora para responder.",
      description_4: "Con este cambio gestionás tus denuncias más rápido y protegés tus marca con mayor eficiencia.",
      button: "Entiendo"
    },

    index: {
      title: "Artículos por denunciar",
      table_th_site: "SITIO",
      table_th_country: "PAÍS",
      table_th_article: "PUBLICACIÓN",
      table_th_auditor: "AUDITOR",
      table_th_price: "PRECIO",
      table_th_antiquity: "REPORTADA HACE",
      table_th_more: "MÁS",
      table_of_text: "de",
      table_next_text: "Siguiente",
      table_rows_text: "filas",
      table_page_text: "Página",
      table_previous_text: "Anterior",
      table_loading_text: "Cargando...",
      table_no_data_text: "No se encontraron datos",
      empty_reports_message: "No hay publicaciones para reportar disponibles.",
      removed_clarification: "Eliminada",
      removed_clarification_tooltip: "No puedes denunciar esta publicación porque ya la eliminamos del sitio.",
      button_remove: "Eliminar",
      removed: "Removido",
      removed_v2: "Publicación inactiva",
      button_send_all_complaints: "ENVIAR TODAS LAS DENUNCIAS",
      button_edit_complaint: "Editar",
      button_send_complaint: "Enviar denuncias",
      button_retry_complaint: "Intentar Nuevamente",
      confirm_reported_article_undo: "¿Desestimar esta publicación?",
      confirm_reported_article_undo_subtitle: "Si haces esto, ya no verás el $title en tu lista de publicaciones sospechosas.",
      confirm_reported_article_undo_btn_label: "Desestimar publicación",
      confirm_send_all_complaints: "Confirma el envío de todas las denuncias?",
      complaint_sent: "Denuncia enviada",
      send_complaint: "Gracias por enviar esta denuncia. Procederemos a evaluarla dentro de las próximas 72hs.",
      send_all_complaints: "Gracias por enviar estas denuncias. Procederemos a evaluarlas dentro de las próximas 72hs.",
      error_send_all_complaints: "Hubo un error al enviar todas las denuncias.",
      error_send_complaint: "Hubo un error al enviar la denuncia.",
      error_send_complaint_already: "La publicación ya fue denunciada.",
      error_getting_article_data: "Hubo un error al buscar los datos",
      failed_not_exits_or_not_published: "El artículo no existe o no está publicado.",
      days: {
        one: "%{count} día",
        other: "%{count} días",
      },
    },
    edit: {
      seller: "Vendedor",
      tags: "Etiquetas",
      complaint_code: "Infracción",
      placeholder_complaint_description: "Escribe aquí tus comentarios sobre la publicación que estás por reportar (opcional).",
      label_add_tag: "Ingresa tus etiquetas",
      cancel_complaint_edition: "Cancelar",
      edit_complaint_edition: "Editar",
    },
    table: {
      th1: "Publicación",
      th2: "Precio",
      th3: "Vendedor",
      th4: "Motivo de denuncia",
    },
  },
  noticed_articles: {
    filter: "Filtrar",
    filters: {
      all: "Todos los estados",
      placeholder_id: "ID",
      placeholder_title: "Publicación",
      placeholder_price_from: "Precio desde",
      placeholder_price_to: "Precio hasta",
      placeholder_date_from: "Fecha desde",
      placeholder_date_to: "Fecha hasta",
      placeholder_country: "País",
      placeholder_seller: "Vendedor",
      report_created: "Reporte generado",
      report_created_error: "Hubo un problema mientras generabamos el reporte",
      report_no_articles_found: "No se encontraron artículos para generar el reporte",
      title_required: "Titulo es requerido",
      date_error: "Fecha desde, no puede ser mayor a fecha hasta",
      price_error: "Precio desde, no puede ser mayor a precio hasta",
    },
    // filter: "Filtrar",
  },
  client_white_sellers: {
    index: {
      ID: "ID",
      title: "Vendedores Confiables",
      empty_sellers_message: "No hay Vendedores Confiables disponibles.",
      table_th_site: "SITIO",
      table_th_country: "PAÍS",
      table_th_seller_name: "VENDEDOR",
      table_th_seller_current_listing: "ARTÍCULOS ACTUALES",
      table_th_actions: "ACCIONES",
      delete_client_white_seller: "Quitar",
      confirm_delete_client_white_seller: "Estás seguro que deseas eliminar a este Vendedor de la lista de Vendedores Confiables?",
      white_list_seller_deleted: "Vendedor confiable eliminado",
      white_list_seller_delete_error: "Hubo un problema mientras intentábamos eliminar a este vendedor. Por favor intenta luego",
      fetch_white_list_seller_error: "Lo sentimos, hubo un error en la búsqueda de vendedores",
    },
  },
  white_and_black_sellers: {
    filters: {
      ID: "ID",
      country: "País",
    },
  },
  notice_reports: {
    index: {
      title: "Reportes",
      table_th_date: "Fecha",
      table_th_name: "Nombre del reporte",
      table_th_download: "Descargar",
      fetch_reports_error: "Hubo un error mientras buscábamos los reportes, por favor inténtalo luego.",
      click_here_to_download: "Click aquí para descargar",
      confirm_delete_report: "¿Está seguro que desea eliminar este reporte? Esta acción no podrá deshacerse.",
      delete_report_error: "Hubo un error eliminando el reporte",
      processing_report: "Procesando reporte",
      generate_error: "Hubo un error al generar este reporte",
      emply_error: "Lo sentimos, no tienes denuncias con los filtros seleccionados",
    },
    create: {
      title: "Nuevo reporte",
      create_report: "Crear reporte",
      placeholder_title: "Título",
      placeholder_date_from: "Fecha desde",
      placeholder_date_to: "Fecha hasta",
      placeholder_currency: "moneda",
      placeholder_origin: "Auditor",
      placeholder_language: "idioma",
    },
  },
  sites_authorization: {
    from_account: {
      do_it_later: "Vincular en otro momento",
      finish_and_do_it_later: "Terminar y vincular luego",
    },
    from_search: {
      back_to_search: "Volver a la búsqueda",
    },
    default: {
      start_reporting: "Empezar a denunciar",
    },
  },
  livesearch_reports: {
    index: {
      title: "Reportes",
      table_th_date: "Fecha",
      table_th_name: "Nombre del reporte",
      table_th_download: "Descargar",
      fetch_reports_error: "Hubo un error mientras buscabamos los reportes, por favor intentalo luego.",
      click_here_to_download: "Click aquí para descargar",
      confirm_delete_report: "¿Está seguro que desea eliminar este reporte? Esta acción no podrá deshacerse.",
      delete_report_error: "Hubo un error eliminando el reporte",
      processing_report: "Procesando reporte",
      generate_error: "Hubo un error al generar este reporte",
    },
  },
  redirect_flow_info: {
    title: "Bienvenido a nuestra nueva herramienta de denuncias",
    subtitle: "Ahora denunciar y responder a los vendedores es mucho más rápido. Mira todo lo que puedes hacer:",
    bullet1: "Identifica más rápido vendedores sospechosos",
    bullet2: "Crea tus propios filtros de búsqueda",
    bullet3: "Sigue el estado de tus denuncias, en un solo lugar",
  },
  tags_title: "Etiquetas",
  label_add_tag: "Ingresa tus etiquetas",
  total: "Totales",
  undo: "Deshacer",
  unknown_seller: "Vendedor desconocido",
  unlist_seller_from_black_list_confirmation: "Estás seguro que deseas eliminar a este Vendedor de la lista de Vendedores Observados?",
  unlist_seller_from_white_list_confirmation: "Estás seguro que deseas eliminar a este Vendedor de la lista de Vendedores Confiables?",
  used_product: "Producto usado",
  validity: "Vigencia",
  view_in_site: "Ver en el sitio",
  initial_question: "P",
  initial_answer: "R",
  seller_information: "Info Vendedor",
  description_product: "Descripción",
  question_answer: "Preguntas y Respuestas",
  welcome: "Bienvenido/a",
  go_back: "Volver",
  edit_reported_article_success: "Se actualizo el reporte a la publicación.",
  edit_reported_article_error: "Lo lamentamos, hemos tenido un error actualizando el reporte.",
  done_article_reported: "¡Listo! Para gestionar y enviar tus denuncias, ve a la sección ",
  done_articles_reported: "¡Listo! Para gestionar y enviar tus denuncias, ve a la sección ",
  done_variant_reported: "¡Listo! Tienes {x} variante marcada. Para gestionar y enviar tus denuncias, dirigite a la sección ",
  done_variants_reported: "¡Listo! Tienes {x} variantes marcadas. Para gestionar y enviar tus denuncias, dirigite a la sección ",
  go_to_reported_articles: "Publicaciones sospechosas.",
  we_will_send_this_listing_to: "Enviaremos esta publicación a",
  we_will_send_these_listing_to: "Enviaremos estas publicaciones a",
  got_it: "ENTENDIDO",
  ls_reported_articles_link: "Ir a Publicaciones sospechosas",
  process_and_clean_results: "Procesar búsqueda",
  live_searches: "Livesearches",
  unable_to_create_live_search: "No pudimos crear la Livesearch. Por favor, intenta nuevamente.",
  server_error: "Lo lamentamos, hemos tenido un error en la respuesta del servidor intenta nuevamente",
  fetch_currency_error: "Lo lamentamos, hemos tenido un error en la respuesta del cambio de moneda",
  remove_article_error: "Lo lamentamos, hemos tenido un error al remover la publicación",
  remove_article_success: "Publicación desestimada.",
  fetch_seller_error: "Lo lamentamos, tuvimos un error en la búsqueda del vendedor",
  dashboard: "Dashboard",
  sellers_inactive: "Vendedores Inactivos",
  tags: "Tags",
  search: "Buscar",
  enter_your_email_below_to_reset_your_password: "Ingresa tu email para resetear tu contraseña",
  error_generating_custom_report: "Error al generar reporte personalizado.",
  without_results: "Sin resultados!",
  refresh: "Actualizar",
  try_again: "Inténtalo nuevamente",
  seller_live_search_created: "Livesearch creada",
  create_seller_live_search: "Crear Livesearch de publicaciones actuales",
  error_reporting_seller: "Error reportando al vendedor. Por favor, intenta nuevamente.",
  error_user_without_report_profile: "No existe el Perfil del Reporte.",
  success_send_all_complaints: "Se enviaron todas las denuncias.",
  updated_reported_article_to_ok: "Se actualizo el estado de la publicación denunciado a OK.",
  reported_article_not_found: "No se encontro el artículo reportado.",
  reported_article_already_reported: "Demasiado tarde, artículo ya reportado.",
  update_reported_article_complaint_success: "Se actualizo la denuncia del artículo reportado.",
  update_reported_article_complaint_error: "No se puedo actualizar la denuncia del artículo reportado, por favor intente nuevamente.",
  complaint_reason: "Motivo de denuncia",
  complaint_error: "Error en Denuncia",
  complaint_description: "Descripcion Complementaria de Denuncia",
  invalid_keyword_for_new_live_search: "Debe ingresar una palabra clave para generar una nueva LiveSearch",
  modal_title: "Cargando...",
  error_getting_snapshot: "No se pudo obtener snapshot del articulo reportado.",
  response_errors: {
    client_error: "Error del cliente",
    server_error: "Error de servidor",
  },
  enroll_rights_cta_tooltip_header: "Ten en cuenta que, antes de adherir nuevos derechos, te pediremos que vuelvas a iniciar sesión con tu nombre de usuario.",
  enroll_rights_tooltip_content: "¿No encuentras el motivo de infracción en la lista? Es posible que te falten adherir derechos.",
  enroll_rights_now: "Adherir ahora",
  report: {
    report_code: {
      PPPI1: "El producto ofrecido es falsificado e infringe mi marca registrada (ej. aplica mi marca registrada a producto no original, etc).",
      PPPI2: "La publicación usa mi marca de manera ilegítima.",
      PPPI3: "El software ofrecido es pirata/ilegal.",
      PPPI4:
        "El producto ofrecido reproduce mi derecho de autor sin autorización (ej. Reproducción de obras plásticas, fonogramas, audiovisuales y libros, etc).",
      PPPI5: "La publicación incluye sin autorización textos originales sobre los que tengo derechos.",
      PPPI6:
        "La publicación incluye sin autorización imágenes originales (ej. fotografías, diseños, dibujos, pinturas, videos, etc) sobre los que tengo derechos.",
      PPPI7: "La publicación incluye mi imagen personal sin autorización (ej. retrato, modelo publicitario).",
      PPPI8: "El producto ofrecido infringe mi modelo o diseño industrial.",
      PPPI9: "El producto ofrecido infringe mi patente o modelo de utilidad.",
      PPPI10: "Producto no destinado para la venta",
      ACUERDO: "Tengo un convenio de regulación sobre este producto.",
    },
  },
  report_variants: {
    title_plural: "Marcar como sospechosas",
    title_s: "Marcar como sospechosa",
    subtitle_copy: "Seleccioná el tipo de obra o creación",
    subtitle_brand: "Seleccioná en dónde se encuentra la infracción",
    subtitle_related: "Actores, cantantes, músicos y bailarines",
    subtitle_p: "Selecciona el tipo de infracción de los productos. Recuerda, todos los productos serán denunciados bajo la misma causa.",
    subtitle_s: "Selecciona el tipo de infracción del producto.",
    variant: "variante",
    variants: "variantes",
    tooltip: "Agrupamos todas las denuncias que hiciste sobre las variantes en un mismo lugar.",
    alert: {
      hasCatalogo: {
        title: "Hay condiciones de venta de catálogo en tu selección",
        subtitle: "Algunos tipos de infracción no son aplicables a las denuncias que realices desde aquí sobre condiciones de venta de catálogo. Sin embargo, sí son aplicables a las denuncias sobre condiciones de venta tradicionales.",
        subtitle2: "Para denunciar las condiciones de venta de catálogo, ve a la página principal de cada una y hazlo desde allí."
      },
      allCatalogo: {
        title: "No es posible denunciar algunas infracciones para condiciones de venta de catálogo",
        subtitle: 'Ten en cuenta que desde aquí no podrás denunciar condiciones de venta de catálogo por: "Uso ilegítimo de marca", "Derechos de autor de imágenes" y "Derechos de autor imagen personal". ',
        subtitle2: "Para denunciarlas, ve a la página principal de cada una y hazlo desde allí."
      }
    }
  },
  report_v2: {
    title: "Marcar como sospechosa",
    title_plural: "Marcar comos sospechosas",
    subtitle: "Selecciona el tipo de infracción",
    title_product: "En el producto ofrecido",
    title_catalog: "Reportar infracción a mis derechos",
    subtitle_catalog: "Aplica para el uso indebido de marcas, incluyendo productos falsificados o productos originales que usan una marca sin autorización. ",
    title_publication: "En el contenido de la publicación",
    title_actors: "Actores, cantantes, músicos y bailarines",
    title_producers: "Productores de fijaciones de sonidos o de imágenes",
    title_broadcastingorganizations: "Organismos de radiodifusión",
    report_code: {
      PPPI1: "Es un producto falsificado",
      PPPI2: "Uso ilegal de mi marca",
      PPPI3: "Software",
      PPPI4: "Infracción de derechos de autor",
      PPPI5: "Libros",
      PPPI6: "Imágenes / fotos",
      PPPI7: "Uso no autorizado de imagen personal",
      PPPI8: "Infringe modelos o diseños industriales",
      PPPI9: "Infringe patentes, modelos de utilidad o variedades vegetales",
      PPPI10: "Es un producto no destinado a la venta",
      PPPI11: "Cursos",
      PPPI12: "Videojuegos",
      PPPI13: "Videos",
      PPPI14: "Videos / Películas",
      PPPI15: "Música",
      PPPI16: "Personajes",
      PPPI17: "Otros",
      PPPI18: "Reproducciones ilegales",
      PPPI19: "Imagen personal",
      PPPI20: "Usa material auditivo sin autorización",
      PPPI21: "Usa material audiovisual sin autorización",
      PPPI22: "Transmisión ilegal",
      PPPI23: "Dispositivo ilegal",
      PPPI24: "Fotoproducto",
      ACUERDO: "Tengo un convenio de regulación sobre este producto.",
      PPPI1_subtext: "Es un producto que lleva mi marca pero que no fue fabricado por mí.",
      PPPI2_subtext: "Incluye mi logo en sus imágenes sin tener autorización; identifica al producto con un nombre o logo confundible con mi marca.",
      PPPI3_subtext: "La publicación ofrece un programa de computación que infringe mis derechos.",
      PPPI4_subtext: "Por ejemplo, libros pdf, compilados de música, copias de películas, productos que incluyan imágenes de obras protegidas.",
      PPPI5_subtext: "La publicación ofrece una obra literaria que infringe mis derechos.",
      PPPI6_subtext: "La publicación contiene imágenes o fotos que infringen mis derechos.",
      PPPI7_subtext: "Por ejemplo, una foto que muestra a una persona sin su autorización",
      PPPI8_subtext: "Indica aquí las posibles infracciones a tus modelos o diseños industriales registrados, incluyendo diseños, formas y monogramas.",
      PPPI9_subtext: "",
      PPPI10_subtext:
        "Ej. Muestras gratis o productos que fueron entregados en comodato. También pueden denunciarse productos no lanzados oficialmente en Brasil.",
      PPPI11_subtext: "La publicación ofrece un curso que infringe mis derechos.",
      PPPI12_subtext: "La publicación ofrece un videojuego que infringe mis derechos.",
      PPPI13_subtext: "",
      PPPI14_subtext: "La publicación ofrece una obra audiovisual que infringe mis derechos.",
      PPPI15_subtext: "La publicación ofrece un contenido musical que infringe mis derechos.",
      PPPI16_subtext: "La publicación ofrece productos que incluyen mis personajes sin autorización.",
      PPPI17_subtext: "La publicación ofrece otro tipo de obra (diseño, pintura, escultura, etc.) que infringe mis derechos.",
      PPPI18_subtext: "Fijaciones o reproducciones no autorizadas.",
      PPPI19_subtext: "Usa mi imagen personal asociada a mi interpretación artística sin autorización.",
      PPPI20_subtext: "Música o sonidos grabados.",
      PPPI21_subtext: "Películas, series, vídeos, grabaciones de recitales, de espectáculos y eventos deportivos.",
      PPPI22_subtext: "Servicios para acceder a señales de manera ilegal.",
      PPPI23_subtext: "Dispositivos que captan señales de manera ilegal.",
      PPPI24_subtext: "La publicación muestra fotos oficiales o de catálogo sin autorización del titular de la marca .",
      ACUERDO_subtext: "",
    },
    catalog_code: {
      PPPI1: "Es un producto falsificado",
      PPPI2: "Uso ilegal de mi marca en la publicación. ",
      PPPI10: "Es un producto no destinado a la venta",
      PPPI1_subtext: "Es un producto que lleva mi marca, pero no fue fabricado por  mí.",
      PPPI2_subtext: "Identifica al producto con un nombre o logo confundible con mi marca, se menciona mi marca cuando el producto no lo es, etc.",
      PPPI10_subtext:
        "Ejemplo: muestras gratis o productos que fueron entregados en comodato.  También pueden denunciarse productos no lanzados oficialmente en Brasil.",
    },
    step_1: {
      copyright: "Infringe derechos de autor",
      copyright_fotoproducto: "Infringe derechos de fotoproducto",
      brand: "Infringe derechos de marca registrada",
      personal_image: "Usa mi imagen personal sin autorización",
      utility_model: "Infringe modelos o diseños industriales",
      patent: "Infringe patentes, modelos de utilidad o variedades vegetales",
      agreements: "Tengo un convenio de regulación sobre este producto",
      related_rights: "Infringe derechos conexos",
    },
    step_2: {
      header: "¿Quieres agregar algo más?",
      header_images: "¿Por qué estás denunciando estas imágenes?",
      subheader_images: "Explica qué derecho de propiedad intelectual se está infringiendo en las imágenes denunciadas.",
      docs_title: "Documentación adherida",
      docs_subtitle: "Selecciona el documento con las imágenes adheridas que vas a usar para respaldar tu caso.",
      title: "Agregar comentario",
      subtitle: "(Opcional)",
      placeholder: "Incluí los detalles de la infracción. Estos comentarios serán visibles para el vendedor denunciado.",
      count: "La denuncia aplicará para ",
      countStrong: "${count} variantes",
      pppi8_subtitle: "Complete la siguiente información para reportar una posible infracción a su diseño registrado.",
      pppi8_field1_label: "Indique el número de su registro por el cual realiza la denuncia",
      pppi8_field1_placeholder: "Ej.: AR-123456, EU-78910, etc.",
      pppi8_field1_note: "Número de registro vigente.",
      pppi8_error_reg_number: "Error al cargar el número de registro",
      pppi8_field2_label: "Describa qué partes de su diseño están protegidas y cómo se diferencian de otros diseños comunes del mercado",
      pppi8_field2_placeholder: "Ej.: Las asas curvas y el patrón diagonal son distintivos frente a diseños comunes de tazas.",
      pppi8_field3_label: "Indique qué partes de su diseño fueron copiadas en el producto denunciado, detallando las similitudes específicas",
      pppi8_field3_placeholder: "Ej.: Coinciden la forma de la base y la proporción del cuerpo, generando la misma impresión general.",
    },
    message_advice: {
      title: "IMPORTANTE",
      message:
        "Tené en cuenta que tu denuncia debe basarse en infracciones de propiedad intelectual que tengas adheridas al Brand Protection Program. El uso inadecuado puede llevar a sanciones en tu cuenta.",
      message_strong: "el uso inadecuado de esta herramienta puede llevar a sanciones en tu cuenta.",
      link: "Conocé qué puedes denunciar",
    },
    tooltip_PPPI10: {
      title: "¡NUEVO!",
      description: "Utiliza este motivo para denunciar infracciones de marca registrada sobre el producto.",
    },

    "select-options": {
      subtitle: "¿Dónde está la infracción?",
      placeholder: "Selecciona una opción",
      "opt-title": "Título",
      "opt-description": "Descripción",
      "opt-sheet": " Ficha técnica",
      "opt-publish": "Publicación",
      subtitle2: "Cuéntanos más sobre la infracción",
      placeholder2: "Incluye aquí los detalles de la infracción.",
      button: "Enviar reporte",
    },
    buybox: {
      title: "¡Listo! Gracias por reportar",
      description: "Hemos procesado tu reporte, lo revisaremos y te contactaremos por correo para darte respuesta",
      "case-number": "Número de caso: ",
    },
    product_subtext_1: "Selecciona esta opción si el producto",
    product_subtext_2: "usa tu marca sin autorización.",
    publication_subtext_1: "Selecciona esta opción si la publicación",
    publication_subtext_2: "menciona tu marca",
    publication_subtext_3: "en el titulo, en la ficha técnica o en la descripción.",
    related_rights_sub: "Indica la infracción que contiene la publicación.",
    copyright_sub: "",
    brand_sub: "",
    personal_image_sub: "",
    utility_model_sub: "Indica aquí las posibles infracciones a tus modelos o diseños industriales registrados, incluyendo diseños, formas y monogramas.",
    patent_sub: "",
    agreements_sub: "",
    copyright_title: "Selecciona el tipo de obra o creación",
    copyright_selected: " en ${reason}",
    utility_patent_selected: " de ${reason}",
    image_hub_title: "Indica cuáles imágene(s) estarían infringiendo tus derechos",
    catalog_product_title: "En el producto ofrecido",
    catalog_publish_title: "En el contenido de la publicación",
    "tooltip-isDenounced": "Este producto ya está reportado ",
    errorDenounce: "Parece que algo salió mal. Por favor, vuelve a intentarlo.",
  },
  datatables: {
    length_menu: "Mostrar _MENU_ filas por página",
    zero_records: "No hay resultados",
    info: "Mostrando _START_ de _END_ de _TOTAL_",
    info_empty: "No hay filas disponibles",
    info_filtered: "(Filtrado desde _MAX_ resultados totales)",
    processing: "Cargando resultados",
    first: "Primero",
    last: "Ultimo",
    next: "Próximo",
    previous: "Previo",
  },
  activerecord: {
    errors: {
      messages: {
        record_invalid: "objeto invalido -> %{errors}",
        wrong_size: "tamaño equivocado (deberia ser %{file_size})",
        size_too_small: "demasiado pequeña (debe ser por lo menos %{file_size})",
        size_too_big: "demasiado grande (deberan ser al menos %{file_size})",
        inclusion: "no está incluído en la lista",
        exclusion: "está reservado",
        invalid: "es inválido",
        confirmation: "no coincide con la confirmación",
        blank: "es requerido",
        empty: "no puede estar vacío",
        not_a_number: "no es un número",
        not_an_integer: "debe ser un entero",
        less_than: "debe ser menor que %{count}",
        less_than_or_equal_to: "debe ser menor o igual que %{count}",
        greater_than: "debe ser mayor que %{count}",
        greater_than_or_equal_to: "debe ser mayor o igual que %{count}",
        too_short: {
          one: "es demasiado corto (mínimo 1 caracter)",
          other: "es demasiado corto (mínimo %{count} caracteres)",
        },
        too_long: {
          one: "es demasiado largo (máximo 1 caracter)",
          other: "es demasiado largo (máximo %{count} caracteres)",
        },
        equal_to: "debe ser igual a %{count}",
        wrong_length: {
          one: "longitud errónea (debe ser de 1 caracter)",
          other: "longitud errónea (debe ser de %{count} caracteres)",
        },
        accepted: "debe ser aceptado",
        even: "debe ser un número par",
        odd: "debe ser un número impar",
        taken: "ya registrado",
        required: "requerido",
      },
    },
    models: {
      user: "Usuario",
    },
    attributes: {
      user: {
        email: "Email",
        first_name: "Nombre",
        last_name: "Apellido",
        password: "Contraseña",
        password_confirmation: "Confirmar Contraseña",
        current_password: "Contraseña Actual",
        currency: "Moneda",
        locale: "Idioma",
        update_password: "Actualizar Contraseña",
        field_required: "Este campo es obligatorio",
        error_rewrite_password: "No coincide con el campo contraseña",
        alert_update_user: "Usuario actualizado",
        alert_not_update_user: "No se realizaron cambios",
      },
    },
  },
  views: {
    pagination: {
      first: "&laquo; Primero",
      last: "Ultimo &raquo;",
      previous: "&lsaquo; Prev",
      next: "Sig &rsaquo;",
      truncate: "&hellip;",
    },
  },
  shared: {
    side_navigation: {
      suggested_listings: "Publicaciones sugeridas",
      searches: "Búsquedas",
      reports: "Denuncias",
      custom_reports: "Reportes de denuncias",
      last_reported_listings: "Historial de denuncias",
      support: "Soporte",
      support_help: "Ayuda",
      management_case: "Gestión de denuncias",
      cases_pending: "Denuncias pendientes",
      cases_closed: "Denuncias cerradas",
      sellers: "Vendedores",
      sellers_black: "Vendedores observados",
      sellers_white: "Vendedores confiables",
      livesearch_reports: "Reportes de Livesearch",
      articles_to_report: "Publicaciones sospechosas por denunciar",
      articles_to_report_tooltip_title: "Tienes denuncias sin enviar",
      articles_to_report_tooltip_text: "Revisa tus publicaciones sospechosas y envía las denuncias desde aquí",
      articles_to_report_tooltip_not_show: "No volver a mostrar",
      support_link: "Soporte",
      video_instructions: "Videos instructivos",
      new_pill: "NUEVO",
      my_account: "Mi Cuenta",
    },
  },
  devise: {
    registrations: {
      edit: {
        title: "Perfil del auditor",
        cancel_button: "Cancelar",
        update_button: "Actualizar",
        help_label_password: "(dejar en blanco sino se desea cambiarlo)",
        help_label_current_password: "(necesitamos su contraseña actual para confirmar los cambios)",
      },
    },
    passwords: {
      edit: {
        title: "Cambiar la contraseña",
        change_passwd_button: "Cambiar mi contraseña",
        placeholder_password: "Nueva contraseña",
        placeholder_confirm_password: "Confirmar nueva contraseña",
      },
    },
    mailer: {
      reset_password_instructions: {
        hello: "Hola",
        date: "Fecha",
        requested_link_text: "Alguien ha pedido un enlace para cambiar tu contraseña. Usted puede hacer esto a través del siguiente link:",
        link_change_my_password: "Cambiar mi contraseña",
        ignore_email_text: "Si usted no ha solicitado el cambio de password, por favor, ignora este mensaje.",
        your_passwd_wont_change_text: "Su contraseña no cambiará hasta que acceda al enlace de arriba y genere una nueva.",
      },
    },
  },
  terms_and_conditions: "Términos y Condiciones",
  privacy_policy: "Políticas de privacidad",
  reviews: {
    button: "Opiniones",
    title_seller_selected: "Opiniones sobre el producto de",
    title_default: "Opiniones sobre el producto",
    subtitle_seller_default: "Aquí encontrarás las opiniones de quienes le han comprado a cada vendedor.",
    subtitle_seller_selected: "Explora las opiniones de quienes le han comprado a este vendedor.",
    subtitle_seller_no_reviews: "El vendedor que seleccionaste aún no ha recibido opiniones sobre sus ventas.",
    all_reviews: "Todas",
    positives: "Positivas",
    negatives: "Negativas",
    view_more: "Ver más",
    view_less: "Ver menos",
  },
  custom_reports: {
    title: 'Reportes',
    no_result: 'No se encontraron resultados para este período',
    no_reports: 'No hay reportes generados',
    nav: {
      stats: 'Estadísticas',
      reports: 'Denuncias',
      generated: 'Reportes generados',
      reports_total: 'Total de denuncias:'
    },
    filter_options: {
      country: 'País',
      auditor: 'Auditor',
      state: 'Estado',
      currency: 'Moneda',
      lang: 'Idioma',
      export_pdf: 'Descargar informe',
      select_columns: 'Seleccionar columnas',
      export_excel: 'Descargar informe'
    },
    metrics_resumen: {
      title_panel: 'Panel de denuncias',
      title_reports: 'Total de denuncias',
      title_removed: 'Denuncias Removidas',
      title_rechazed: 'Denuncias Rechazadas',
      title_reactived: 'Denuncias Reactivadas',
      title_progress: 'Denuncias Pendientes de Revisión',
      info_progress: 'La denuncia está siendo procesada internamente por el sistema.'
    },
    graph_motivos: {
      title: 'Motivos más denunciados',
      header_reason: 'Motivo',
      header_detail: 'Detalle',
      header_report: 'Denuncias',
      header_percent: 'Porcentaje'
    },
    graph_country: {
      title: 'Países más auditados',
      header_country: 'País',
      header_report: 'Denuncias enviadas',
      header_percent: 'Porcentaje'
    },
    list_sellers: {
      title_top_ten: 'Top diez vendedores más denunciados',
      title: 'Vendedores más denunciados',
      header_seller: 'ID del vendedor',
      header_report: 'Denuncias recibidas',
      header_location: 'Ubicación'
    },
    modal_print: {
      title: 'Exportar a',
      filename: 'Nombre de archivo',
      lang: 'Idioma',
      print: 'Generar',
      report_date_range: 'Reporte desde el {{from}} al {{to}}'
    },
    details: {
      header_country: 'País',
      header_seller: 'Vendedor',
      header_id: 'ID de publicación',
      header_title: 'Nombre de la publicación',
      header_localPrice: 'Precio local',
      header_customPrice: 'Precio en',
      header_auditor: 'Auditor',
      header_reason: 'Motivo',
      header_status: 'Estado',
      header_date: 'Fecha',
      not_results: 'No se encontraron resultados para tu búsqueda',
      show: 'Mostrar',
      results_per_page: 'Resultados por página',
      previous: 'Anterior',
      next: 'Siguiente',
      placeholder_search: 'Buscar por título, vendedor o ID...',
      price_not_available: 'No disponible',
      loading_prices: 'Cargando...'
    }
  },
  reportesV2: {
    all: 'Todos',
    select_columns: 'Seleccionar Columnas',
    columns: {
      all: 'Todas',
      country: 'País',
      seller: 'Vendedor',
      id: 'ID Publicación',
      title: 'Nombre de publicación',
      localPrice: 'Precio Local',
      usdPrice: 'Precio en',
      auditor: 'Auditor',
      reason: 'Motivo',
      status: 'Estado',
      date: 'Fecha'
    },
    states: {
      all: 'Todos',
      removed: 'Removidas',
      rejected: 'Rechazadas',
      reactivated: 'Reactivadas',
      in_progress: 'En Progreso'
    },
    status_label: {
      removed: 'Removida',
      rejected: 'Rechazada',
      reactivated: 'Reactivada',
      in_progress: 'En Progreso'
    }
  },
  massiveLoadV2: {
    upload_subtitle: "Sube tu archivo Excel con las publicaciones a reportar en lote",
    report_subtitle: "Informe de carga masiva",
    error_subtitle: "Se produjo un error al procesar la información",
    title: "Carga masiva de publicaciones sospechosas",
    back_to_start: "Volver al inicio",
    success_message: "Se procesó con éxito el archivo de lote",
    ready_for_batch: "Listos para procesamiento en lote",
    sample_data_title: "Muestra de datos cargados:",
    item_id_label: "Item ID:",
    code_label: "Código:",
    description_label: "Descripción:",
    more_elements: "... y {{count}} elementos más",
    view_details: "Ver Detalles",
    invalid_code_format: "Formato inválido en el campo code (línea {{line}}): debe tener solo las opciones permitidas",
    invalid_description_format: "Formato inválido en el campo description (línea {{line}}): debe tener al menos 5 caracteres y contener solo caracteres válidos",
    invalid_excel_format: "Formato inválido en el Excel:\n\n{{errors}}\n\nPor favor, corrija estos errores y vuelva a cargar el archivo.",
    batch_error: "Error al procesar el lote: ",
    unknown_batch_error: "Error desconocido al procesar el lote",
    no_articles_loaded: "No se pudo cargar ningun articulo que fue importado",
    country_found: "Pais encontrado",
    countries_found: "Paises encontrados",
    article_validation_failed: "Artículo con validación fallida",
    articles_validation_failed: "Artículos con validación fallida",
    summary_title: "Resumen",
    countries_loaded: "Países cargados",
    articles_count: "Cantidad de artículos",
    errors_by_type: "Cantidad de errores por tipo",
    not_found: "  - No encontrados",
    duplicated: "  - Duplicados",
    validation_failed: "  - Validación fallida",
    validation_failed_label: "Validación fallida",
    blindages: "  - Blindajes",
    load_date: "Fecha de carga",
    line_number: "Numero de linea",
    raw_field: "Campo cargado sin decodificar del excel",
    identified_article: "Articulo identificado",
    report: "Denuncia",
    description: "Descripcion",
    all_lines: "Todas las líneas",
    item_id: "Item ID",
    reason: "Razón",
    due_date: "Fecha de vencimiento"
  }
};

export default es;
